// import React, { useState, useEffect, useMemo } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { Phone, Calendar, Users, ChevronLeft, ChevronRight, Search, Download, X, Eye, Wallet, Building, Mail, MapPin, CreditCard, UserCheck, TrendingUp, Activity, BarChart2 } from 'lucide-react';
// import { useNavigate } from "react-router-dom";
// import { GetSoftwarePlan, GetHardwarePlan, GiveManagerAccess, GetWalletTracking } from '../../../services/oprations/Bussiness_Logic';
// import { Get_Managers_User } from '../../../services/oprations/Users';
// import { generateInvoicePDF } from '../../../utils/GenerateInvoicePDF';
// import { useToast } from "../../Toast";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer
// } from 'recharts';

// // ─── Sub-components (Shared) ──────────────────────────────────────────────────────────

// const PlanTypeBadge = ({ type }) => {
//   const isSoftware = type?.toLowerCase().includes("software");
//   return (
//     <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
//       isSoftware 
//         ? "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400" 
//         : "bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-400"
//     }`}>
//       <span className={`w-1.5 h-1.5 rounded-full ${
//         isSoftware ? "bg-green-500 dark:bg-green-400" : "bg-orange-500 dark:bg-orange-400"
//       }`} />
//       {isSoftware ? "Recharge" : "Purchase"}
//     </span>
//   );
// };

// const getLastDayOfMonth = (date) => {
//   return new Date(date.getFullYear(), date.getMonth() + 1, 0);
// };

// const formatDateToInput = (date) => {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
//   return `${year}-${month}-${day}`;
// };

// // ─── Wallet Balance Tooltip ─────────────────────────────────────────────────────────
// const WalletBalanceTooltip = ({ active, payload, label }) => {
//   if (active && payload && payload.length) {
//     const data = payload[0]?.payload;
//     if (!data) return null;
    
//     return (
//       <div style={{ 
//         backgroundColor: '#1e3a8a', 
//         border: '1px solid #3b82f6', 
//         borderRadius: '0.5rem', 
//         padding: '12px 16px', 
//         color: 'white', 
//         fontSize: '13px',
//         minWidth: '200px'
//       }}>
//         <p style={{ marginBottom: 8, fontWeight: 600, color: '#93c5fd', borderBottom: '1px solid #3b82f6', paddingBottom: 4 }}>
//           {label ? new Date(label).toLocaleDateString("en-IN", { 
//             day: "2-digit", 
//             month: "long", 
//             year: "numeric" 
//           }) : 'No Date'}
//         </p>
//         <p style={{ margin: '4px 0', color: '#60a5fa' }}>
//           Total Users: <strong>{data.subtractAmount || 0}</strong>
//         </p>
//         <p style={{ margin: '4px 0', color: '#f87171' }}>
//           Subtracted Amount: <strong>-₹{(data.subtractAmount || 0).toLocaleString('en-IN')}</strong>
//         </p>
//         <p style={{ margin: '4px 0', color: '#34d399' }}>
//           Current Balance: <strong>₹{(data.totalAmount || 0).toLocaleString('en-IN')}</strong>
//         </p>
//       </div>
//     );
//   }
//   return null;
// };

// // ─── Date Range Picker (Responsive) ─────────────────────────────────────────────────────────
// const DateRangePicker = ({ startDate, endDate, onStartDateChange, onEndDateChange, onApply }) => {
//   const [isMobileOpen, setIsMobileOpen] = useState(false);
  
//   return (
//     <>
//       {/* Mobile Trigger */}
//       <button
//         onClick={() => setIsMobileOpen(true)}
//         className="flex items-center gap-2 px-3 py-2 text-sm text-white bg-blue-600 rounded-lg md:hidden"
//       >
//         <Calendar className="w-4 h-4" />
//         <span>Select Date</span>
//       </button>
      
//       {/* Mobile Modal */}
//       {isMobileOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 md:hidden" onClick={() => setIsMobileOpen(false)}>
//           <div className="w-full max-w-sm p-4 bg-[#0d1526] border border-blue-800/50 rounded-xl" onClick={e => e.stopPropagation()}>
//             <div className="flex justify-between mb-4">
//               <h3 className="text-white">Select Date Range</h3>
//               <button onClick={() => setIsMobileOpen(false)} className="text-blue-400"><X className="w-5 h-5" /></button>
//             </div>
//             <div className="space-y-3">
//               <input type="date" value={startDate} onChange={(e) => onStartDateChange(e.target.value)} className="w-full p-2 text-white bg-transparent border rounded border-blue-700/50 date-input" />
//               <input type="date" value={endDate} onChange={(e) => onEndDateChange(e.target.value)} className="w-full p-2 text-white bg-transparent border rounded border-blue-700/50 date-input" />
//               <button onClick={() => { onApply(); setIsMobileOpen(false); }} className="w-full py-2 text-white bg-blue-600 rounded-lg">Apply</button>
//             </div>
//           </div>
//         </div>
//       )}
      
//       {/* Desktop View */}
//       <div className="items-center hidden gap-2 p-1 border rounded-lg md:flex bg-richblue-600/20 border-blue-700/80">
//         <input type="date" value={startDate} onChange={(e) => onStartDateChange(e.target.value)} className="px-2 py-1 text-sm text-white bg-transparent border rounded border-blue-700/50 focus:outline-none focus:ring-1 focus:ring-blue-500 date-input" />
//         <span className="text-blue-400">to</span>
//         <input type="date" value={endDate} onChange={(e) => onEndDateChange(e.target.value)} className="px-2 py-1 text-sm text-white bg-transparent border rounded border-blue-700/50 focus:outline-none focus:ring-1 focus:ring-blue-500 date-input" />
//         <button onClick={onApply} className="px-3 py-1 text-xs text-white transition-colors bg-blue-600 rounded hover:bg-blue-500">Apply</button>
//       </div>
//     </>
//   );
// };

// // ─── Plan Detail Drawer (Responsive) ────────────────────────────────────────────────────────
// const PlanDetailDrawer = ({ plan, onClose }) => {
//   if (!plan) return null;

//   const inv = plan.invoiceId || {};
//   const hasInvoice = !!plan.invoiceId;

//   const formatDate = (iso) => {
//     if (!iso) return "N/A";
//     const d = new Date(iso);
//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit", month: "short", year: "numeric",
//     }) + " " + d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
//   };

//   const amount   = inv.amount ?? plan.ammount ?? plan.amount ?? 0;
//   const currency = inv.currency || "INR";
//   const symbol   = currency === "INR" ? "₹" : currency + " ";

//   const detailRows = [
//     ["Organization",  inv.orgname   || plan.orgname],
//     ["Email",         inv.email     || plan.email],
//     ["Phone",         inv.phone     || plan.phone],
//     ["Address",       inv.address],
//     ["GST",           inv.gst && inv.gst !== "NA" ? inv.gst : null],
//     ["Invoice No.",   inv.invoiceNumber],
//     ["Payment",       String(inv.paymentStatus).toLowerCase() === "true" ? "Paid ✓" : "Unpaid"],
//     ["Currency",      currency],
//     ["Created At",    formatDate(inv.createdAt || plan.createdAt)],
//     ["Created By",    inv.createdby],
//     ["Updated At",    formatDate(inv.updatedAt  || plan.updatedAt)],
//   ];

//   return (
//     <>
//       {/* Backdrop */}
//       <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      
//       {/* Drawer - full width on mobile, sidebar on desktop */}
//       <div className="fixed inset-y-0 right-0 z-50 w-full max-w-full md:max-w-sm bg-[#0d1526] border-l border-blue-800/40 shadow-2xl transform transition-transform duration-300 ease-out animate-in slide-in-from-right">
//         <div className="flex flex-col h-full overflow-y-auto">
//           {/* Header */}
//           <div className="sticky top-0 z-10 flex items-center justify-between p-4 border-b bg-[#0d1526]/95 backdrop-blur-sm border-blue-800/40">
//             <h3 className="text-base font-bold text-white">Plan Details</h3>
//             <button onClick={onClose} className="p-1 text-blue-400 transition-colors rounded-lg hover:text-white hover:bg-blue-900/30">
//               <X className="w-5 h-5" />
//             </button>
//           </div>

//           {/* Content */}
//           <div className="flex-1 p-4 space-y-4">
//             {/* Amount Hero */}
//             <div className="py-4 text-center border rounded-xl bg-green-900/10 border-green-800/20">
//               <p className="text-2xl font-bold text-green-300 md:text-3xl">
//                 <span className="pr-1 text-xl md:text-2xl">{symbol}</span>
//                 {amount.toLocaleString("en-IN")}
//               </p>
//               <p className="mt-1 text-xs text-blue-300 md:text-sm">{inv.name || plan.name}</p>
//               <div className="flex items-center justify-center gap-2 mt-2">
//                 <PlanTypeBadge type={plan.recipt} />
//                 {hasInvoice && (
//                   <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${
//                     String(inv.paymentStatus).toLowerCase() === "true"
//                       ? "bg-green-900/30 text-green-300 border-green-700/30"
//                       : "bg-red-900/30 text-red-300 border-red-700/30"
//                   }`}>
//                     {String(inv.paymentStatus).toLowerCase() === "true" ? "Paid" : "Unpaid"}
//                   </span>
//                 )}
//               </div>
//             </div>

//             {/* No Invoice Notice */}
//             {!hasInvoice && (
//               <div className="p-3 border rounded-lg bg-amber-900/20 border-amber-700/30">
//                 <p className="text-xs text-amber-400">⚠ Invoice not yet generated for this transaction. Ask your admin to generate one before downloading.</p>
//               </div>
//             )}

//             {/* Detail Rows */}
//             <div className="space-y-0 divide-y divide-blue-800/15">
//               {detailRows.map(([label, val]) => val && (
//                 <div key={label} className="flex justify-between items-start py-2.5">
//                   <span className="w-24 text-xs text-gray-400 shrink-0">{label}</span>
//                   <span className="text-xs text-blue-200 font-medium text-right max-w-[180px] break-words">{val}</span>
//                 </div>
//               ))}
//             </div>

//             {/* Download Button */}
//             <button
//               disabled={!hasInvoice}
//               onClick={() => generateInvoicePDF(plan)}
//               className={`w-full py-3 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition-all ${
//                 hasInvoice
//                   ? "bg-blue-700 hover:bg-blue-600 text-white shadow-lg shadow-blue-900/30"
//                   : "bg-blue-900/20 text-blue-600 border border-blue-800/30 cursor-not-allowed"
//               }`}
//             >
//               <Download className="w-4 h-4" />
//               {hasInvoice ? "Download Invoice PDF" : "Invoice Not Available"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// // ─── Manager Access Modal (Responsive) ──────────────────────────────────────────────────────
// const ManagerAccessModal = ({ managers, onClose, onSave, loading }) => {
//   const [selected, setSelected] = useState(
//     managers.filter(m => m.hasBillingAccess).map(m => m.id)
//   );
//   const [saving, setSaving] = useState(false);

//   const toggle = (id) =>
//     setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

//   const handleSaveClick = async () => {
//     setSaving(true);
//     await onSave(selected);
//     setSaving(false);
//     onClose();
//   };

//   if (loading) {
//     return (
//       <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose}>
//         <div className="w-full max-w-md bg-[#0d1526] border border-blue-800/50 rounded-2xl p-6 text-center">
//           <div className="w-8 h-8 mx-auto mb-3 border-2 border-blue-500 rounded-full border-t-transparent animate-spin" />
//           <p className="text-sm text-blue-400">Loading managers...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose}>
//       <div
//         className="w-full max-w-md bg-[#0d1526] border border-blue-800/50 rounded-2xl shadow-2xl shadow-blue-900/30 p-4 md:p-6 max-h-[90vh] overflow-y-auto"
//         onClick={e => e.stopPropagation()}
//       >
//         <div className="flex items-center justify-between mb-4">
//           <h3 className="text-base font-bold text-white md:text-lg">Billing Access — Managers</h3>
//           <button onClick={onClose} className="p-1 text-blue-400 transition-colors rounded-lg hover:text-white hover:bg-blue-900/30">
//             <X className="w-5 h-5" />
//           </button>
//         </div>
//         <p className="mb-4 text-xs text-blue-500">Select which managers can view the Billing &amp; Plan section.</p>
        
//         <div className="space-y-2 overflow-y-auto max-h-64">
//           {managers.length === 0 ? (
//             <div className="py-8 text-center text-blue-500">No managers found</div>
//           ) : managers.map(m => (
//             <label key={m.id} className="flex items-center gap-3 p-3 transition-colors border cursor-pointer rounded-xl border-blue-800/30 bg-blue-900/10 hover:bg-blue-900/20">
//               <input type="checkbox" checked={selected.includes(m.id)} onChange={() => toggle(m.id)} className="w-4 h-4 accent-blue-500" />
//               <div className="flex items-center flex-1 gap-3">
//                 <div className="flex items-center justify-center w-8 h-8 text-xs font-bold text-blue-200 rounded-full bg-blue-700/40">
//                   {m.name.split(' ').map(n => n[0]).join('')}
//                 </div>
//                 <div className="flex-1 min-w-0">
//                   <p className="text-sm font-medium text-white truncate">{m.name}</p>
//                   <p className="text-xs text-blue-500 truncate">{m.email}</p>
//                   <p className="text-xs text-blue-600">{m.role || 'Manager'}</p>
//                 </div>
//               </div>
//               <span className={`text-xs px-2 py-0.5 rounded-full border whitespace-nowrap ${
//                 selected.includes(m.id)
//                   ? 'bg-green-900/30 text-green-300 border-green-700/30'
//                   : 'bg-gray-800 text-gray-500 border-gray-700'
//               }`}>
//                 {selected.includes(m.id) ? 'Access' : 'No Access'}
//               </span>
//             </label>
//           ))}
//         </div>
        
//         <div className="flex flex-col gap-2 mt-5 sm:flex-row">
//           <button
//             onClick={handleSaveClick}
//             disabled={saving}
//             className="flex items-center justify-center gap-2 p-3 text-sm font-semibold text-white transition-colors bg-blue-700 rounded-xl hover:bg-blue-600 disabled:opacity-60"
//           >
//             {saving ? (
//               <>
//                 <div className="w-4 h-4 border-2 border-white rounded-full border-t-transparent animate-spin" />
//                 Saving...
//               </>
//             ) : 'Save Changes'}
//           </button>
//           <button
//             onClick={onClose}
//             disabled={saving}
//             className="p-3 text-sm text-blue-300 transition-colors border rounded-xl border-blue-600/50 hover:text-white disabled:opacity-60"
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Stat Card Component ──────────────────────────────────────────────────────────
// const StatCard = ({ label, value, sub, color, icon: Icon }) => (
//   <div className="p-3 border rounded-xl bg-richblue-600/20 border-blue-700/80 md:p-4">
//     <div className="flex items-center justify-between">
//       <p className="text-xs text-blue-300 sm:text-sm">{label}</p>
//       {Icon && <Icon className="w-4 h-4 text-blue-400 md:w-5 md:h-5" />}
//     </div>
//     <p className={`text-xl font-bold md:text-2xl ${color}`}>{value}</p>
//     <p className="text-xs text-gray-500 sm:text-sm">{sub}</p>
//   </div>
// );

// // ─── Mobile Plan Card ──────────────────────────────────────────────────────────
// const MobilePlanCard = ({ plan, onClick }) => (
//   <div
//     className="p-4 transition-colors border cursor-pointer bg-blue-950/10 border-blue-800/25 rounded-xl hover:bg-blue-900/20"
//     onClick={() => onClick(plan)}
//   >
//     <div className="flex items-start justify-between mb-2">
//       <div className="flex-1 pr-3">
//         <p className="text-sm font-medium leading-snug text-white">{plan.name}</p>
//         <p className="mt-0.5 text-xs text-blue-400">{plan.orgname}</p>
//       </div>
//       <p className="text-base font-bold text-green-300 whitespace-nowrap">
//         ₹{(plan.ammount ?? plan.amount ?? 0).toLocaleString('en-IN')}
//       </p>
//     </div>
//     <div className="flex flex-wrap items-center gap-2">
//       <PlanTypeBadge type={plan.recipt} />
//       <span className="flex-1 text-xs text-blue-400 truncate">{plan.email}</span>
//       <span className="text-xs text-blue-400">·</span>
//       <span className="text-xs text-blue-400 whitespace-nowrap">
//         {new Date(plan.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}
//       </span>
//     </div>
//     <div className="flex justify-end mt-2">
//       <span className="flex items-center gap-1 text-xs text-blue-200">
//         View Details <Eye className="w-3 h-3" />
//       </span>
//     </div>
//   </div>
// );

// // ─── Main Component ────────────────────────────────────────────────────────────
// const OrgBillingComplete = () => {
//   const toast = useToast();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { user } = useSelector((state) => state.profile);
//   const { token } = useSelector((state) => state.auth);
//   const { managers } = useSelector((state) => state.manager);

//   const managersData = typeof managers === 'string' ? JSON.parse(managers) : managers;
//   const userDetails = typeof user === 'string' ? JSON.parse(user) : user;

//   const [loading, setLoading] = useState(true);
//   const [loadingManagers, setLoadingManagers] = useState(true);
//   const [activeTab, setActiveTab] = useState('plans');
//   const [showManagerModal, setShowManagerModal] = useState(false);

//   const [search, setSearch] = useState('');
//   const [page, setPage] = useState(1);
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const PER_PAGE = 8;

//   const currentDate = new Date();

//   const [startDate, setStartDate] = useState(() => {
//     const date = new Date();
//     date.setDate(1);
//     return formatDateToInput(date);
//   });

//   const [endDate, setEndDate] = useState(() => {
//     return formatDateToInput(getLastDayOfMonth(currentDate));
//   });

//   const [tempStartDate, setTempStartDate] = useState(startDate);
//   const [tempEndDate, setTempEndDate] = useState(endDate);

//   const [softwarePlans, setSoftwarePlans] = useState([]);
//   const [hardwarePlans, setHardwarePlans] = useState([]);
//   const [managerAccessList, setManagerAccessList] = useState([]);

//   // Wallet Analysis State
//   const [walletHistoryData, setWalletHistoryData] = useState([]);
//   const [walletStats, setWalletStats] = useState({
//     maxBalance: 0,
//     minBalance: 0,
//     avgBalance: 0,
//     totalTransactions: 0,
//     recentTransactions: []
//   });

//   const orgData = useMemo(() => ({
//     name: userDetails?.org_name || 'TechCorp Pvt Ltd',
//     email: userDetails?.org_email || 'admin@techcorp.com',
//     phone: userDetails?.phone_number || '+91 98765 43210',
//     gst: userDetails?.gst_number || 'GST27AABCT1234A1Z5',
//     address: userDetails?.location || '4th Floor, DLF Tower, Sector 25, Gurugram, Haryana - 122001',
//     memberSince: userDetails?.createdAt?.split('T')[0] || 'Jan 2024',
//     total_users: userDetails?.total_users || 0,
//     wallet: {
//       balance: userDetails?.wallet?.balance ?? 9160,
//     },
//   }), [userDetails]);
//  console.log("orgdata", userDetails)
//   const mngData = useMemo(() => ({
//     name: userDetails?.manager_name,
//     email: userDetails?.manager_email,
//     org_name: userDetails?.org_id?.org_name || 'TechCorp Pvt Ltd',
//     org_email: userDetails?.org_id?.org_email || 'admin@techcorp.com',
//     phone: userDetails?.org_id?.phone_number || '+91 98765 43210',
//     gst: userDetails?.org_id?.gst || 'GST27AABCT1234A1Z5',
//     address: userDetails?.org_id?.location || '4th Floor, DLF Tower, Sector 25, Gurugram, Haryana - 122001',
//     memberSince: userDetails?.org_id?.createdAt?.split("T")[0] || 'Jan 2024',
//     total_users: userDetails?.org_id?.total_users || 0,
//     wallet: {
//       balance: userDetails?.org_id?.wallet?.balance ?? 9160,
//     },
//   }), [userDetails]);

//   // ── Helper: Sort plans in descending order by createdAt ──────────────────────────
//   const sortPlansDescending = (plansArray) => {
//     if (!plansArray || !Array.isArray(plansArray)) return [];
//     return [...plansArray].sort((a, b) => {
//       const dateA = new Date(a.createdAt);
//       const dateB = new Date(b.createdAt);
//       return dateB - dateA;
//     });
//   };

//   // ── Fetch Wallet Balance ─────────────────────────────────────────────────────────
//   const fetchWalletBalance = async () => {
//     try {
//       const res = await dispatch(GetWalletTracking());
//       console.log("wallet tracking...", res);
      
//       const walletData = res?.data?.data || res?.payload?.data || res;
      
//       if (walletData && Array.isArray(walletData)) {
//         // Filter by date range
//         const filtered = walletData.filter(item => {
//           const itemDate = item.DateString?.split('T')[0];
//           return itemDate >= startDate && itemDate <= endDate;
//         });
        
//         // Sort ascending for chart (oldest first)
//         const ascendingData = [...filtered].sort((a, b) => 
//           new Date(a.DateString) - new Date(b.DateString)
//         );
        
//         // Format for chart
//         const chartData = ascendingData.map(item => ({
//           date: item.DateString,
//           totalAmount: item.totalamount,
//           subtractAmount: item.subtractamount,
//           totalUsers: item.orgId?.total_users || item.orgId?.totalUsers || 0,
//           orgName: item.orgId?.org_name || item.orgId?.orgName
//         }));
        
//         setWalletHistoryData(chartData);
        
//         // Calculate statistics
//         const balances = chartData.map(d => d.totalAmount);
//         const maxBalance = balances.length > 0 ? Math.max(...balances) : 0;
//         const minBalance = balances.length > 0 ? Math.min(...balances) : 0;
//         const avgBalance = balances.length > 0 ? Math.round(balances.reduce((a, b) => a + b, 0) / balances.length) : 0;
        
//         // Sort descending for table (newest first)
//         const descendingData = [...filtered].sort((a, b) => 
//           new Date(b.DateString) - new Date(a.DateString)
//         );
        
//         setWalletStats({
//           maxBalance,
//           minBalance,
//           avgBalance,
//           totalTransactions: chartData.length,
//           recentTransactions: descendingData.slice(0, 5)
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching wallet data:", error);
//     }
//   };

//   // ── Fetch Managers ───────────────────────────────────────────────────────────
//   const fetchManagers = async () => {
//     try {
//       setLoadingManagers(true);
//       await dispatch(Get_Managers_User(token));

//       const processedManagers = (managersData || []).map(manager => ({
//         id: manager._id || manager.id,
//         name: manager.manager_name || manager.name,
//         email: manager.manager_email || manager.email,
//         role: manager.role || 'Manager',
//         hasBillingAccess: manager.access || false,
//       }));

//       setManagerAccessList(processedManagers);
//     } catch (err) {
//       console.error("Error fetching managers:", err);
//       toast.error("Failed to load managers data");
//     } finally {
//       setLoadingManagers(false);
//     }
//   };

//   useEffect(() => {
//     fetchManagers();
//   }, []);

//   // ── Fetch Plans ──────────────────────────────────────────────────────────────
//   const fetchPlans = async () => {
//     try {
//       const softwareRes = await dispatch(GetSoftwarePlan(token));
//       const sortedSoftwarePlans = sortPlansDescending(softwareRes || []);
//       setSoftwarePlans(sortedSoftwarePlans);
      
//       const hardwareRes = await dispatch(GetHardwarePlan(token));
//       const sortedHardwarePlans = sortPlansDescending(hardwareRes || []);
//       setHardwarePlans(sortedHardwarePlans);
//     } catch (err) {
//       console.error("Error fetching plans:", err);
//       toast.error("Failed to load plans data");
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   useEffect(() => {
//     if (token) fetchPlans();
//   }, [token]);

//   // Fetch wallet data when date range changes
//   useEffect(() => {
//     if (token) fetchWalletBalance();
//   }, [startDate, endDate, token]);

//   // ── Filtered Plans (maintaining sort order) ───────────────────────────────────────────
//   const filteredByDatePlans = useMemo(() => {
//     const startDateObj = new Date(startDate);
//     startDateObj.setHours(0, 0, 0, 0);
//     const endDateObj = new Date(endDate);
//     endDateObj.setHours(23, 59, 59, 999);

//     return softwarePlans.filter(plan => {
//       if (!plan.createdAt) return false;
//       const planDate = new Date(plan.createdAt);
//       return planDate >= startDateObj && planDate <= endDateObj;
//     });
//   }, [softwarePlans, startDate, endDate]);

//   const filteredPlans = useMemo(() => {
//     if (!search) return filteredByDatePlans;
//     return filteredByDatePlans.filter(plan =>
//       plan.name?.toLowerCase().includes(search.toLowerCase()) ||
//       plan.orgname?.toLowerCase().includes(search.toLowerCase()) ||
//       plan.email?.toLowerCase().includes(search.toLowerCase())
//     );
//   }, [filteredByDatePlans, search]);

//   const totalPages = Math.ceil(filteredPlans.length / PER_PAGE);
//   const paginatedPlans = filteredPlans.slice((page - 1) * PER_PAGE, page * PER_PAGE);

//   const planSummary = useMemo(() => {
//     const totalRevenue = softwarePlans.reduce((sum, p) => sum + (p.ammount ?? p.amount ?? 0), 0);
//     const totalFilteredRevenue = filteredByDatePlans.reduce((sum, p) => sum + (p.ammount ?? p.amount ?? 0), 0);
//     return {
//       totalPlans: softwarePlans.length,
//       totalRevenue,
//       totalFilteredPlans: filteredByDatePlans.length,
//       totalFilteredRevenue,
//     };
//   }, [softwarePlans, filteredByDatePlans]);

//   const currentMonthRevenue = useMemo(() => {
//     const now = new Date();
//     const start = new Date(now.getFullYear(), now.getMonth(), 1);
//     start.setHours(0, 0, 0, 0);
//     const end = getLastDayOfMonth(now);
//     end.setHours(23, 59, 59, 999);

//     return softwarePlans
//       .filter(plan => {
//         if (!plan.createdAt) return false;
//         const d = new Date(plan.createdAt);
//         return d >= start && d <= end;
//       })
//       .reduce((sum, p) => sum + (p.ammount ?? p.amount ?? 0), 0);
//   }, [softwarePlans]);

//   const TABS = [
//     { id: 'plans', label: 'Transactions', icon: CreditCard },
//     { id: 'wallet', label: 'Wallet Analysis', icon: TrendingUp },
//     userDetails.role === "Organization" && { id: 'access', label: 'Manager Access', icon: UserCheck },
//   ].filter(Boolean);

//   const handleApplyDateFilter = () => {
//     setStartDate(tempStartDate);
//     setEndDate(tempEndDate);
//     setPage(1);
//   };

//   const formatDisplayDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-IN', {
//       day: '2-digit', month: 'short', year: 'numeric'
//     });
//   };

//   // ── Handle Save Manager Access ───────────────────────────────────────────────
//   const handleSaveManagers = async (selectedIds) => {
//     const changedManagers = managerAccessList.filter(manager => {
//       const newAccess = selectedIds.includes(manager.id);
//       return newAccess !== manager.hasBillingAccess;
//     });

//     if (changedManagers.length === 0) {
//       toast.success('No changes to save');
//       return;
//     }

//     try {
//       const results = await Promise.all(
//         changedManagers.map(manager =>
//           dispatch(GiveManagerAccess(manager.id, selectedIds.includes(manager.id), token))
//         )
//       );

//       const anyFailed = results.some(r => !r || r?.data?.success === false);
      
//       if (!anyFailed) {
//         setManagerAccessList(prev =>
//           prev.map(m => ({
//             ...m,
//             hasBillingAccess: selectedIds.includes(m.id),
//           }))
//         );
//         toast.success('Manager access updated successfully');
//       } else {
//         toast.error('Failed to update some manager access');
//       }
//     } catch (error) {
//       console.error('Failed to update manager access:', error);
//       toast.error('Failed to update manager access. Please try again.');
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-[#0B0F1C] flex items-center justify-center">
//         <div className="text-center">
//           <div className="w-10 h-10 mx-auto mb-3 border-2 border-blue-500 rounded-full border-t-transparent animate-spin" />
//           <p className="text-sm text-blue-400/60">Loading plan requests...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className={`min-h-screen bg-[#0B0F1C] text-white font-sans ${userDetails.role === "Manager" ? "pt-20 md:pt-24" : "pt-4 md:pt-0"}`}>
//       <div className="px-3 py-4 mx-auto space-y-4 max-w-7xl md:px-4 md:py-6 md:space-y-6">

//         {/* ── Org Header (Responsive) ──────────────────────────────────────────────────────── */}
//         {userDetails.role === "Organization" && (
//           <div className="p-3 border rounded-2xl bg-richblue-800/20 border-blue-700/80 md:p-4">
//             <div className="flex flex-col gap-4 md:flex-row md:items-center">
//               <div className="flex items-center flex-1 gap-3">
//                 <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 text-lg font-bold border shadow-lg rounded-2xl bg-gradient-to-br from-blue-600 to-blue-900 border-blue-500/20 shadow-blue-900/40 md:w-14 md:h-14 md:text-xl">
//                   {orgData.name.slice(0, 2).toUpperCase()}
//                 </div>
//                 <div className="flex-1 min-w-0">
//                   <h1 className="text-lg font-bold text-white truncate md:text-xl">{orgData.name}</h1>
//                   <p className="text-xs text-blue-300 truncate md:text-sm">{orgData.email}</p>
//                   <div className="flex flex-wrap items-center gap-1 mt-1 md:gap-2">
//                     <span className="flex items-center gap-0.5 text-xs text-blue-200"><Phone className="w-3 h-3 md:w-4 md:h-4"/> {orgData.phone}</span>
//                     <span className="text-xs text-blue-200">•</span>
//                     <span className="text-xs text-blue-200">Since {orgData.memberSince}</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Wallet Card - Responsive */}
//               <div className="bg-black border border-blue-700/80 rounded-xl p-2 min-w-[140px] md:min-w-[170px]">
//                 <p className="text-[10px] md:text-xs font-medium tracking-wider text-blue-200 uppercase">Wallet Balance</p>
//                 <p className="text-lg font-bold text-white md:text-xl">
//                   ₹{orgData.wallet.balance.toLocaleString('en-IN')}
//                   <span className="ml-1 text-xs font-normal text-blue-200">INR</span>
//                 </p>
//                 <div className="flex items-center gap-1 mt-0.5">
//                   <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" />
//                   <span className="text-[10px] text-green-400/70 md:text-xs">Active</span>
//                 </div>
//                 <button
//                   onClick={() => navigate('/purchase-software/plan')}
//                   className="w-full py-1.5 mt-2 text-[10px] md:text-xs font-semibold text-white transition-colors bg-blue-700 rounded-lg hover:bg-blue-600"
//                 >
//                   + Recharge
//                 </button>
//               </div>
//             </div>

//             {/* Org Details - Responsive Grid */}
//             <div className="grid grid-cols-1 gap-2 p-2 mt-2 border-t border-blue-800/20 sm:grid-cols-2">
//               <div>
//                 <p className="text-[10px] text-gray-300 mb-0.5 md:text-xs">GST Number</p>
//                 <p className="font-mono text-xs text-blue-200 break-all md:text-sm">{orgData.gst}</p>
//               </div>
//               <div>
//                 <p className="text-[10px] text-gray-300 mb-0.5 md:text-xs">Billing Address</p>
//                 <p className="text-xs leading-snug text-blue-200 break-words md:text-sm">{orgData.address}</p>
//               </div>
//             </div>
//           </div>
//         )}
        
//         {/* ── Manager View Header ──────────────────────────────────────────────────────── */}
//         {userDetails.role === "Manager" && (
//           <div className="p-3 border rounded-2xl bg-richblue-800/20 border-blue-700/80 md:p-4">
//             <div className="flex flex-col gap-4 md:flex-row md:items-center">
//               <div className="flex items-center flex-1 gap-3">
//                 <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 text-lg font-bold border shadow-lg rounded-2xl bg-gradient-to-br from-blue-600 to-blue-900 border-blue-500/20 shadow-blue-900/40 md:w-14 md:h-14 md:text-xl">
//                   {mngData.org_name.slice(0, 2).toUpperCase()}
//                 </div>
//                 <div className="flex-1 min-w-0">
//                   <h1 className="text-lg font-bold text-white truncate md:text-xl">{mngData.org_name}</h1>
//                   <p className="text-xs text-blue-300 truncate md:text-sm">{mngData.org_email}</p>
//                   <div className="flex flex-wrap items-center gap-1 mt-1 md:gap-2">
//                     <span className="flex items-center gap-0.5 text-xs text-blue-200"><Phone className="w-3 h-3 md:w-4 md:h-4"/> {mngData.phone}</span>
//                     <span className="text-xs text-blue-200">•</span>
//                     <span className="text-xs text-blue-200">Since {mngData.memberSince}</span>
//                   </div>
//                 </div>
//               </div>

//               <div className="bg-black border border-blue-700/80 rounded-xl p-2 min-w-[140px] md:min-w-[170px]">
//                 <p className="text-[10px] md:text-xs font-medium tracking-wider text-blue-200 uppercase">Wallet Balance</p>
//                 <p className="text-lg font-bold text-white md:text-xl">
//                   ₹{mngData.wallet.balance.toLocaleString('en-IN')}
//                   <span className="ml-1 text-xs font-normal text-blue-200">INR</span>
//                 </p>
//                 <div className="flex items-center gap-1 mt-0.5">
//                   <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" />
//                   <span className="text-[10px] text-green-400/70 md:text-xs">Active</span>
//                 </div>
//                 <button
//                   onClick={() => navigate('/purchase-software/plan')}
//                   className="w-full py-1.5 mt-2 text-[10px] md:text-xs font-semibold text-white transition-colors bg-blue-700 rounded-lg hover:bg-blue-600"
//                 >
//                   + Recharge
//                 </button>
//               </div>
//             </div>

//             <div className="grid grid-cols-1 gap-2 p-2 mt-2 border-t border-blue-800/20 sm:grid-cols-2">
//               <div>
//                 <p className="text-[10px] text-gray-300 mb-0.5 md:text-xs">GST Number</p>
//                 <p className="font-mono text-xs text-blue-200 break-all md:text-sm">{mngData.gst}</p>
//               </div>
//               <div>
//                 <p className="text-[10px] text-gray-300 mb-0.5 md:text-xs">Billing Address</p>
//                 <p className="text-xs leading-snug text-blue-200 break-words md:text-sm">{mngData.address}</p>
//               </div>
//             </div>
//           </div>
//         )}
        
//         {/* ── Stats Grid (Responsive: 2x2 on mobile, 4 column on desktop) ────────────────── */}
//         {userDetails.role === 'Organization' && activeTab === 'plans' && (
//           <div className="grid grid-cols-2 gap-2 md:gap-3 sm:grid-cols-4">
//             <StatCard label="Total Records" value={planSummary.totalFilteredPlans} sub={`Out of ${planSummary.totalPlans}`} color="text-blue-300" icon={CreditCard} />
//             <StatCard label="Total Amount" value={`₹${planSummary.totalFilteredRevenue.toLocaleString('en-IN')}`} sub={`Total ₹${planSummary.totalRevenue.toLocaleString('en-IN')}`} color="text-green-400" icon={Wallet} />
//             <StatCard label="Current Month" value={`₹${currentMonthRevenue.toLocaleString('en-IN')}`} sub="This month's total" color="text-amber-300" icon={Calendar} />
//             <StatCard label="Total Users" value={orgData.total_users} sub={`${orgData.total_users} users`} color="text-blue-300" icon={Users} />
//           </div>
//         )}

//         {/* Wallet Analysis Stats */}
//         {/* {activeTab === 'wallet' && walletHistoryData.length > 0 && (
//           <div className="grid grid-cols-2 gap-2 md:gap-3 sm:grid-cols-4">
//             <StatCard label="Current Balance" value={`₹${walletHistoryData[walletHistoryData.length - 1]?.totalAmount?.toLocaleString('en-IN') || 0}`} sub="Latest balance" color="text-green-400" icon={Wallet} />
//             <StatCard label="Highest Balance" value={`₹${walletStats.maxBalance.toLocaleString('en-IN')}`} sub="Peak balance" color="text-blue-300" icon={TrendingUp} />
//             <StatCard label="Lowest Balance" value={`₹${walletStats.minBalance.toLocaleString('en-IN')}`} sub="Lowest point" color="text-amber-300" icon={Activity} />
//             <StatCard label="Avg Balance" value={`₹${walletStats.avgBalance.toLocaleString('en-IN')}`} sub="Average daily" color="text-purple-300" icon={BarChart2} />
//           </div>
//         )} */}

//         {/* ── Tabs (Responsive: full width on mobile, fit on desktop) ────────────────────── */}
//         <div className="flex flex-wrap w-full gap-1 p-1 border bg-blue-950/30 border-blue-800/30 rounded-xl md:w-fit">
//           {TABS.map(tab => (
//             <button
//               key={tab.id}
//               onClick={() => { setActiveTab(tab.id); if (tab.id !== 'plans') setPage(1); }}
//               className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium transition-all flex-1 md:flex-none justify-center ${
//                 activeTab === tab.id
//                   ? 'bg-blue-700 text-white shadow-lg shadow-blue-900/40'
//                   : 'text-blue-300 hover:text-blue-100'
//               }`}
//             >
//               <tab.icon className="w-3.5 h-3.5 md:w-4 md:h-4" />
//               {tab.label}
//             </button>
//           ))}
//         </div>

//         {/* ── Plans Tab ───────────────────────────────────────────────────────── */}
//         {activeTab === 'plans' && (
//           <div className="space-y-4">
//             {/* Search and Date Filter Row - Responsive stacking */}
//             <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
//               <div className="relative flex-1 min-w-[0]">
//                 <Search className="absolute w-4 h-4 transform -translate-y-1/2 left-3 top-1/2 text-blue-400/60" />
//                 <input
//                   type="text"
//                   placeholder="Search by name, organization or email..."
//                   value={search}
//                   onChange={e => { setSearch(e.target.value); setPage(1); }}
//                   className="w-full py-2 pr-4 text-sm text-white border rounded-lg pl-9 bg-richblue-600/20 border-blue-700/80 placeholder-blue-400/40 focus:outline-none focus:ring-2 focus:ring-blue-700"
//                 />
//               </div>
//               <DateRangePicker
//                 startDate={tempStartDate}
//                 endDate={tempEndDate}
//                 onStartDateChange={setTempStartDate}
//                 onEndDateChange={setTempEndDate}
//                 onApply={handleApplyDateFilter}
//               />
//             </div>

//             {/* Date Range Display */}
//             <div className="flex items-center gap-1.5 text-xs text-blue-300 md:text-sm">
//               <Calendar className="w-3.5 h-3.5 md:w-4 md:h-4" />
//               <span>Showing from <strong>{formatDisplayDate(startDate)}</strong> to <strong>{formatDisplayDate(endDate)}</strong></span>
//               <span className="text-blue-400/60">({filteredPlans.length} plans)</span>
//             </div>

//             {/* Desktop Table View (hidden on mobile) */}
//             <div className="hidden md:block">
//               <div className="border shadow-xl bg-richblue-800/20 border-blue-700/80 rounded-xl shadow-blue-800/60">
//                 <div className="overflow-x-auto overflow-y-auto max-h-[500px] rounded-xl">
//                   <table className="w-full text-left border-collapse">
//                     <thead className="sticky top-0 z-10 bg-richblue-950">
//                       <tr className="border-b border-blue-800/30 bg-blue-900/10">
//                         {['Name', 'Organization', 'Email', 'Phone No.', 'Amount', 'Created At', ''].map(h => (
//                           <th key={h} className="px-4 py-3 text-xs font-bold tracking-wider text-left text-blue-300 uppercase whitespace-nowrap">{h}</th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody className="divide-y divide-blue-900/20">
//                       {paginatedPlans.length === 0 ? (
//                         <tr>
//                           <td colSpan="7" className="py-12 text-center text-gray-400">No plan requests found in selected date range</td>
//                         </tr>
//                       ) : paginatedPlans.map((plan) => (
//                         <tr
//                           key={plan._id}
//                           className="transition-colors cursor-pointer hover:bg-blue-900/10"
//                           onClick={() => setSelectedPlan(plan)}
//                         >
//                           <td className="px-4 py-3 text-sm font-medium text-white whitespace-nowrap">{plan.name}</td>
//                           <td className="px-4 py-3 text-sm text-gray-300 whitespace-nowrap">{plan.orgname}</td>
//                           <td className="px-4 py-3 text-sm text-blue-300 whitespace-nowrap">{plan.email}</td>
//                           <td className="px-4 py-3 text-sm font-light text-gray-500 whitespace-nowrap">{plan.phone}</td>
//                           <td className="px-4 py-3 text-sm font-semibold text-green-300 whitespace-nowrap">
//                             ₹{(plan.ammount ?? plan.amount ?? 0).toLocaleString('en-IN')}
//                           </td>
//                           <td className="px-4 py-3 text-xs text-gray-400 whitespace-nowrap">
//                             {new Date(plan.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
//                           </td>
//                           <td className="px-4 py-3 text-xs text-blue-300 hover:text-blue-100">
//                             <Eye className="w-4 h-4" />
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>

//             {/* Mobile Card View */}
//             <div className="space-y-3 md:hidden">
//               {paginatedPlans.length === 0 ? (
//                 <div className="py-12 text-sm text-center text-blue-400/40">No plan requests found</div>
//               ) : paginatedPlans.map(plan => (
//                 <MobilePlanCard key={plan._id} plan={plan} onClick={setSelectedPlan} />
//               ))}
//             </div>

//             {/* Responsive Pagination */}
//             {totalPages > 1 && (
//               <div className="flex flex-col items-center gap-3 pt-2 sm:flex-row sm:justify-between">
//                 <p className="order-2 text-xs text-blue-200 sm:order-1">
//                   Showing {(page - 1) * PER_PAGE + 1}–{Math.min(page * PER_PAGE, filteredPlans.length)} of {filteredPlans.length}
//                 </p>
//                 <div className="flex flex-wrap justify-center order-1 gap-1 sm:order-2">
//                   <button
//                     disabled={page === 1}
//                     onClick={() => setPage(p => p - 1)}
//                     className="p-1.5 text-xs md:px-2 text-blue-200 disabled:opacity-30 transition-colors"
//                   >
//                     <ChevronLeft className="w-3.5 h-3.5" />
//                   </button>
//                   {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
//                     let pageNum;
//                     if (totalPages <= 5) pageNum = i + 1;
//                     else if (page <= 3) pageNum = i + 1;
//                     else if (page >= totalPages - 2) pageNum = totalPages - 4 + i;
//                     else pageNum = page - 2 + i;
//                     return (
//                       <button
//                         key={pageNum}
//                         onClick={() => setPage(pageNum)}
//                         className={`px-2.5 py-1.5 text-xs rounded-lg transition-colors md:px-3 ${
//                           pageNum === page ? 'bg-blue-700 text-white border border-blue-500' : 'border border-gray-700/50 text-gray-500 hover:bg-blue-700/40 hover:text-gray-300'
//                         }`}
//                       >
//                         {pageNum}
//                       </button>
//                     );
//                   })}
//                   <button
//                     disabled={page === totalPages}
//                     onClick={() => setPage(p => p + 1)}
//                     className="p-1.5 text-xs md:px-2 text-blue-200 disabled:opacity-30  transition-colors"
//                   >
//                     <ChevronRight className="w-3.5 h-3.5" />
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         {/* ── Wallet Analysis Tab ───────────────────────────────────────────────────────── */}
//         {activeTab === 'wallet' && (
//           <div className="space-y-4">
//             {/* Date Range Filter for Wallet */}
//             <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-end">
//               <DateRangePicker
//                 startDate={tempStartDate}
//                 endDate={tempEndDate}
//                 onStartDateChange={setTempStartDate}
//                 onEndDateChange={setTempEndDate}
//                 onApply={handleApplyDateFilter}
//               />
//             </div>

//             {/* Date Range Display */}
//             <div className="flex items-center gap-1.5 text-xs text-blue-300 md:text-sm">
//               <Calendar className="w-3.5 h-3.5 md:w-4 md:h-4" />
//               <span>Showing from <strong>{formatDisplayDate(startDate)}</strong> to <strong>{formatDisplayDate(endDate)}</strong></span>
//               <span className="text-blue-400/60">({walletHistoryData.length} records)</span>
//             </div>

//             {/* Wallet Balance Chart */}
//             {walletHistoryData.length > 0 ? (
//               <>
//                 <div className="p-4 border rounded-xl bg-richblue-800/20 border-blue-700/80 md:p-6">
//                   <div className="flex items-center justify-between mb-6">
//                     <div>
//                       <h3 className="text-base font-semibold text-white md:text-lg">Balance History</h3>
//                       <p className="text-xs text-blue-300">Daily wallet balance tracking</p>
//                     </div>
//                     <Wallet className="w-5 h-5 text-blue-400" />
//                   </div>
                  
//                   <div className="h-80">
//                     <ResponsiveContainer width="100%" height="100%">
//                       <LineChart data={walletHistoryData} margin={{ top: 20, right: 30, left: 10, bottom: 10 }}>
//                         <defs>
//                           <linearGradient id="walletGradient" x1="0" y1="0" x2="0" y2="1">
//                             <stop offset="5%" stopColor="#34d399" stopOpacity={0.3} />
//                             <stop offset="95%" stopColor="#34d399" stopOpacity={0} />
//                           </linearGradient>
//                         </defs>
//                         <CartesianGrid strokeDasharray="3 3" stroke="#2563eb20" />
//                         <XAxis 
//                           dataKey="date" 
//                           stroke="#60a5fa"
//                           tick={{ fill: '#93c5fd', fontSize: 11 }}
//                           tickFormatter={(value) => {
//                             const d = new Date(value);
//                             return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
//                           }}
//                           angle={-45}
//                           textAnchor="end"
//                           height={70}
//                           interval={walletHistoryData.length > 14 ? Math.floor(walletHistoryData.length / 14) : 0}
//                         />
//                         <YAxis 
//                           stroke="#60a5fa"
//                           tick={{ fill: '#93c5fd', fontSize: 11 }}
//                           tickFormatter={(v) => '₹' + v.toLocaleString('en-IN')}
//                           label={{ 
//                             value: 'Balance (₹)', 
//                             angle: -90, 
//                             position: 'insideLeft',
//                             style: { fill: '#93c5fd', fontSize: 12 }
//                           }}
//                         />
//                         <Tooltip content={<WalletBalanceTooltip />} />
//                         <Legend 
//                           formatter={(value) => <span className="text-blue-200">Daily Balance</span>}
//                           wrapperStyle={{ paddingTop: '10px' }}
//                         />
//                         <Line 
//                           type="monotone" 
//                           dataKey="totalAmount" 
//                           stroke="#34d399" 
//                           strokeWidth={2.5}
//                           name="Balance"
//                           dot={{ r: 4, fill: "#34d399", strokeWidth: 2 }}
//                           activeDot={{ r: 6, fill: "#34d399", stroke: "#0f172a", strokeWidth: 2 }}
//                           fillOpacity={0.3}
//                           fill="url(#walletGradient)"
//                         />
//                       </LineChart>
//                     </ResponsiveContainer>
//                   </div>
//                 </div>

//                 {/* Recent Transactions Table */}
//                 {walletStats.recentTransactions.length > 0 && (
//                   <div className="p-4 border rounded-xl bg-richblue-800/20 border-blue-700/80 md:p-6">
//                     <h3 className="mb-4 text-base font-semibold text-white md:text-lg">Balance History</h3>
//                     <div className="overflow-x-auto">
//                       <div className="max-h-[400px] overflow-y-auto relative">
//                         <table className="w-full border-collapse">
//                           <thead className="sticky top-0 z-10">
//                             <tr className="uppercase border-b border-blue-800/30 bg-blue-900/10">
//                               <th className="px-3 py-3 text-xs font-bold tracking-wider text-left text-blue-300 whitespace-nowrap">Date</th>
//                               <th className="px-3 py-3 text-xs font-bold tracking-wider text-left text-blue-300 whitespace-nowrap">Total Users</th>
//                               <th className="px-3 py-3 text-xs font-bold tracking-wider text-left text-blue-300 whitespace-nowrap">Subtracted Amount</th>
//                               <th className="px-3 py-3 text-xs font-bold tracking-wider text-left text-blue-300 whitespace-nowrap">Current Balance</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {walletStats.recentTransactions.map((transaction, idx) => (
//                               <tr 
//                                 key={idx} 
//                                 className={`border-b border-blue-800/20 hover:bg-blue-900/20 transition-colors ${
//                                   idx % 2 === 0 ? 'bg-blue-900/5' : ''
//                                 }`}
//                               >
//                                 <td className="px-3 py-3 text-xs text-gray-200 whitespace-nowrap">
//                                   {new Date(transaction.DateString).toLocaleDateString("en-IN", {
//                                     day: "2-digit",
//                                     month: "short",
//                                     year: "numeric"
//                                   })}
//                                 </td>
//                                 <td className="px-3 py-3 text-xs text-gray-400 whitespace-nowrap">
//                                   {transaction.subtractamount || transaction.orgId?.totalUsers || 0}
//                                 </td>
//                                 <td className="px-3 py-3 text-xs text-red-400 whitespace-nowrap">
//                                   -₹{(transaction.subtractamount || 0).toLocaleString('en-IN')}
//                                 </td>
//                                 <td className="px-3 py-3 text-xs font-medium text-green-400 whitespace-nowrap">
//                                   ₹{(transaction.totalamount || 0).toLocaleString('en-IN')}
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
                        
//                         {/* Scroll Indicator */}
//                         {walletStats.recentTransactions.length > 5 && (
//                           <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-[#0B0F1C] to-transparent pointer-events-none"></div>
//                         )}
//                       </div>
                      
//                       {/* Scroll Hint for Mobile */}
//                       {walletStats.recentTransactions.length > 3 && (
//                         <div className="mt-3 text-center">
//                           <p className="flex items-center justify-center gap-1 text-xs text-blue-400/60">
//                             <svg className="w-3 h-3 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//                             </svg>
//                             Scroll for more
//                             <svg className="w-3 h-3 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//                             </svg>
//                           </p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}
//               </>
//             ) : (
//               <div className="flex flex-col items-center justify-center py-12 border rounded-xl bg-richblue-800/20 border-blue-700/80">
//                 <Wallet className="w-12 h-12 text-blue-700" />
//                 <p className="mt-3 text-blue-300">No wallet data available for selected date range</p>
//               </div>
//             )}
//           </div>
//         )}

//         {/* ── Manager Access Tab (Responsive) ───────────────────────────────────────────────── */}
//         {userDetails.role === "Organization" && activeTab === 'access' && (
//           <div className="p-4 border rounded-xl border-blue-700/80 bg-richblue-800/20 md:p-5">
//             <div className="flex flex-col gap-3 mb-4 sm:flex-row sm:items-center sm:justify-between">
//               <h3 className="flex items-center gap-2 text-sm font-semibold text-blue-300 md:text-base">
//                 <Users className="w-4 h-4 md:w-5 md:h-5" /> Manager Billing Access
//               </h3>
//               <button
//                 onClick={() => setShowManagerModal(true)}
//                 className="text-xs px-3 py-1.5 bg-blue-700 hover:bg-blue-600 text-white rounded-lg transition-colors font-medium w-full sm:w-auto"
//               >
//                 Manage Access
//               </button>
//             </div>
//             <p className="mb-4 text-xs text-blue-500">Managers with access can view billing, plans, invoices, and transaction history.</p>
            
//             <div className="space-y-2">
//               {loadingManagers ? (
//                 <div className="py-8 text-center">
//                   <div className="w-6 h-6 mx-auto border-2 border-blue-500 rounded-full border-t-transparent animate-spin" />
//                   <p className="mt-2 text-xs text-blue-400/60">Loading managers...</p>
//                 </div>
//               ) : managerAccessList.length === 0 ? (
//                 <div className="py-8 text-center text-blue-400/40">No managers found for this organization</div>
//               ) : managerAccessList.map(m => (
//                 <div key={m.id} className="flex flex-col gap-2 p-3 border rounded-xl border-blue-800/20 bg-black/20 sm:flex-row sm:items-center sm:justify-between">
//                   <div className="flex items-center gap-3">
//                     <div className="flex items-center justify-center text-xs font-bold text-blue-200 rounded-full w-9 h-9 bg-blue-800/40">
//                       {m.name.split(' ').map(n => n[0]).join('')}
//                     </div>
//                     <div className="min-w-0">
//                       <p className="text-sm font-medium text-white truncate">{m.name}</p>
//                       <p className="text-xs text-blue-500 truncate">{m.role} · {m.email}</p>
//                     </div>
//                   </div>
//                   <span className={`text-xs font-medium px-2.5 py-1 rounded-full border w-fit ${
//                     m.hasBillingAccess
//                       ? 'bg-green-900/30 text-green-300 border-green-700/30'
//                       : 'bg-gray-800 text-gray-500 border-gray-700'
//                   }`}>
//                     {m.hasBillingAccess ? 'Has Access' : 'No Access'}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* ── Modals / Drawers ─────────────────────────────────────────────────── */}
//       {showManagerModal && (
//         <ManagerAccessModal
//           managers={managerAccessList}
//           loading={loadingManagers}
//           onClose={() => setShowManagerModal(false)}
//           onSave={handleSaveManagers}
//         />
//       )}
//       {selectedPlan && (
//         <PlanDetailDrawer plan={selectedPlan} onClose={() => setSelectedPlan(null)} />
//       )}
//     </div>
//   );
// };

// export default OrgBillingComplete;

import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Phone, Calendar, Users, ChevronLeft, ChevronRight, Search, Download, X, Eye, Wallet, CreditCard, UserCheck, TrendingUp } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { GetSoftwarePlan, GetHardwarePlan, GiveManagerAccess, GetWalletTracking } from '../../../services/oprations/Bussiness_Logic';
import { Get_Managers_User } from '../../../services/oprations/Users';
import { generateInvoicePDF } from '../../../utils/GenerateInvoicePDF';
import { useToast } from "../../Toast";
import { useTheme } from '../../../Context/themeContext';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

// ─── Sub-components (Shared) ──────────────────────────────────────────────────────────

const PlanTypeBadge = ({ type }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const isSoftware = type?.toLowerCase().includes("software");
  
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
      isSoftware 
        ? isDark ? "bg-green-900/30 text-green-400" : "bg-green-100 text-green-800"
        : isDark ? "bg-orange-900/30 text-orange-400" : "bg-orange-100 text-orange-800"
    }`}>
      <span className={`w-1.5 h-1.5 rounded-full ${
        isSoftware ? "bg-green-500 dark:bg-green-400" : "bg-orange-500 dark:bg-orange-400"
      }`} />
      {isSoftware ? "Recharge" : "Purchase"}
    </span>
  );
};

const getLastDayOfMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

const formatDateToInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// ─── Wallet Balance Tooltip ─────────────────────────────────────────────────────────
const WalletBalanceTooltip = ({ active, payload, label }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  
  if (active && payload && payload.length) {
    const data = payload[0]?.payload;
    if (!data) return null;
    
    return (
      <div style={{ 
        backgroundColor: isDark ? '#1e3a8a' : '#ffffff', 
        border: `1px solid ${isDark ? '#3b82f6' : '#93c5fd'}`, 
        borderRadius: '0.5rem', 
        padding: '12px 16px', 
        color: isDark ? 'white' : '#1a1a2e', 
        fontSize: '13px',
        minWidth: '200px',
        boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
      }}>
        <p style={{ marginBottom: 8, fontWeight: 600, color: isDark ? '#93c5fd' : '#3b82f6', borderBottom: `1px solid ${isDark ? '#3b82f6' : '#93c5fd'}`, paddingBottom: 4 }}>
          {label ? new Date(label).toLocaleDateString("en-IN", { 
            day: "2-digit", 
            month: "long", 
            year: "numeric" 
          }) : 'No Date'}
        </p>
        <p style={{ margin: '4px 0', color: isDark ? '#60a5fa' : '#2563eb' }}>
          Total Users: <strong>{data.subtractAmount || 0}</strong>
        </p>
        <p style={{ margin: '4px 0', color: isDark ? '#f87171' : '#dc2626' }}>
          Subtracted Amount: <strong>-₹{(data.subtractAmount || 0).toLocaleString('en-IN')}</strong>
        </p>
        <p style={{ margin: '4px 0', color: isDark ? '#34d399' : '#059669' }}>
          Current Balance: <strong>₹{(data.totalAmount || 0).toLocaleString('en-IN')}</strong>
        </p>
      </div>
    );
  }
  return null;
};

// ─── Date Range Picker (Responsive) ─────────────────────────────────────────────────────────
const DateRangePicker = ({ startDate, endDate, onStartDateChange, onEndDateChange, onApply }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  
  const bgInput = isDark ? 'bg-transparent' : 'bg-white/10';
  const borderColor = isDark ? 'border-blue-700/50' : 'border-gray-300';
  const textColor = isDark ? 'text-white' : 'text-gray-900';
  const labelColor = isDark ? 'text-blue-400' : 'text-gray-600';
  const modalBg = isDark ? 'bg-[#0d1526]' : 'bg-white';
  const modalBorder = isDark ? 'border-blue-800/50' : 'border-gray-300';
  
  return (
    <>
      {/* Mobile Trigger */}
      <button
        onClick={() => setIsMobileOpen(true)}
        className="flex items-center gap-2 px-3 py-2 text-sm text-white bg-blue-600 rounded-lg md:hidden"
      >
        <Calendar className="w-4 h-4" />
        <span>Select Date</span>
      </button>
      
      {/* Mobile Modal */}
      {isMobileOpen && (
        <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${isDark ? 'bg-black/80' : 'bg-black/40'} md:hidden`} onClick={() => setIsMobileOpen(false)}>
          <div className={`w-full max-w-sm p-4 ${modalBg} border ${modalBorder} rounded-xl`} onClick={e => e.stopPropagation()}>
            <div className="flex justify-between mb-4">
              <h3 className={textColor}>Select Date Range</h3>
              <button onClick={() => setIsMobileOpen(false)} className={isDark ? 'text-blue-400' : 'text-gray-600'}><X className="w-5 h-5" /></button>
            </div>
            <div className="space-y-3">
              <input type="date" value={startDate} onChange={(e) => onStartDateChange(e.target.value)} className={`w-full p-2 ${textColor} ${bgInput} border rounded ${borderColor} date-input`} />
              <input type="date" value={endDate} onChange={(e) => onEndDateChange(e.target.value)} className={`w-full p-2 ${textColor} ${bgInput} border rounded ${borderColor} date-input`} />
              <button onClick={() => { onApply(); setIsMobileOpen(false); }} className="w-full py-2 text-white bg-blue-600 rounded-lg">Apply</button>
            </div>
          </div>
        </div>
      )}
      
      {/* Desktop View */}
      <div className={`items-center hidden gap-2 p-1 border rounded-lg md:flex ${isDark ? 'bg-richblue-600/20 border-blue-700/80' : 'bg-gray-100 border-gray-300'}`}>
        <input type="date" value={startDate} onChange={(e) => onStartDateChange(e.target.value)} className={`px-2 py-1 text-sm ${textColor} ${bgInput} border rounded ${borderColor} focus:outline-none focus:ring-1 focus:ring-blue-500 date-input`} />
        <span className={labelColor}>to</span>
        <input type="date" value={endDate} onChange={(e) => onEndDateChange(e.target.value)} className={`px-2 py-1 text-sm ${textColor} ${bgInput} border rounded ${borderColor} focus:outline-none focus:ring-1 focus:ring-blue-500 date-input`} />
        <button onClick={onApply} className="px-3 py-1 text-xs text-white transition-colors bg-blue-600 rounded hover:bg-blue-500">Apply</button>
      </div>
    </>
  );
};

// ─── Plan Detail Drawer (Responsive) ────────────────────────────────────────────────────────
const PlanDetailDrawer = ({ plan, onClose }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  if (!plan) return null;

  const inv = plan.invoiceId || {};
  const hasInvoice = !!plan.invoiceId;

  const formatDate = (iso) => {
    if (!iso) return "N/A";
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
    }) + " " + d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
  };

  const amount   = inv.amount ?? plan.ammount ?? plan.amount ?? 0;
  const currency = inv.currency || "INR";
  const symbol   = currency === "INR" ? "₹" : currency + " ";

  const detailRows = [
    ["Organization",  inv.orgname   || plan.orgname],
    ["Email",         inv.email     || plan.email],
    ["Phone",         inv.phone     || plan.phone],
    ["Address",       inv.address],
    ["GST",           inv.gst && inv.gst !== "NA" ? inv.gst : null],
    ["Invoice No.",   inv.invoiceNumber],
    ["Payment",       String(inv.paymentStatus).toLowerCase() === "true" ? "Paid ✓" : "Unpaid"],
    ["Currency",      currency],
    ["Created At",    formatDate(inv.createdAt || plan.createdAt)],
    ["Created By",    inv.createdby],
    ["Updated At",    formatDate(inv.updatedAt  || plan.updatedAt)],
  ];

  const bgDrawer = isDark ? 'bg-[#0d1526]' : 'bg-white';
  const borderColor = isDark ? 'border-blue-800/40' : 'border-gray-200';
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-400' : 'text-gray-600';
  //const textMuted = isDark ? 'text-gray-400' : 'text-gray-500';
  //const textBlue = isDark ? 'text-blue-300' : 'text-blue-700';

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      
      {/* Drawer */}
      <div className={`fixed inset-y-0 right-0 z-50 w-full max-w-full md:max-w-sm ${bgDrawer} border-l ${borderColor} shadow-2xl transform transition-transform duration-300 ease-out animate-in slide-in-from-right`}>
        <div className="flex flex-col h-full overflow-y-auto">
          {/* Header */}
          <div className={`sticky top-0 z-10 flex items-center justify-between p-4 border-b ${bgDrawer}/95 backdrop-blur-sm ${borderColor}`}>
            <h3 className={`text-base font-bold ${textPrimary}`}>Plan Details</h3>
            <button onClick={onClose} className={`p-1 ${isDark ? 'text-blue-400 hover:text-white hover:bg-blue-900/30' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100'} transition-colors rounded-lg`}>
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="flex-1 p-4 space-y-4">
            {/* Amount Hero */}
            <div className={`py-4 text-center border rounded-xl ${isDark ? 'bg-green-900/10 border-green-800/20' : 'bg-green-50 border-green-200'}`}>
              <p className={`text-2xl font-bold ${isDark ? 'text-green-300' : 'text-green-700'} md:text-3xl`}>
                <span className="pr-1 text-xl md:text-2xl">{symbol}</span>
                {amount.toLocaleString("en-IN")}
              </p>
              <p className={`mt-1 text-xs ${isDark ? 'text-blue-300' : 'text-gray-600'} md:text-sm`}>{inv.name || plan.name}</p>
              <div className="flex items-center justify-center gap-2 mt-2">
                <PlanTypeBadge type={plan.recipt} />
                {hasInvoice && (
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${
                    String(inv.paymentStatus).toLowerCase() === "true"
                      ? isDark ? "bg-green-900/30 text-green-300 border-green-700/30" : "bg-green-100 text-green-700 border-green-300"
                      : isDark ? "bg-red-900/30 text-red-300 border-red-700/30" : "bg-red-100 text-red-700 border-red-300"
                  }`}>
                    {String(inv.paymentStatus).toLowerCase() === "true" ? "Paid" : "Unpaid"}
                  </span>
                )}
              </div>
            </div>

            {/* No Invoice Notice */}
            {!hasInvoice && (
              <div className={`p-3 border rounded-lg ${isDark ? 'bg-amber-900/20 border-amber-700/30' : 'bg-amber-50 border-amber-200'}`}>
                <p className={`text-xs ${isDark ? 'text-amber-400' : 'text-amber-700'}`}>⚠ Invoice not yet generated for this transaction. Ask your admin to generate one before downloading.</p>
              </div>
            )}

            {/* Detail Rows */}
            <div className={`space-y-0 divide-y ${isDark ? 'divide-blue-800/15' : 'divide-gray-200'}`}>
              {detailRows.map(([label, val]) => val && (
                <div key={label} className="flex justify-between items-start py-2.5">
                  <span className={`w-24 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'} shrink-0`}>{label}</span>
                  <span className={`text-xs ${isDark ? 'text-blue-200' : 'text-gray-700'} font-medium text-right max-w-[180px] break-words`}>{val}</span>
                </div>
              ))}
            </div>

            {/* Download Button */}
            <button
              disabled={!hasInvoice}
              onClick={() => generateInvoicePDF(plan)}
              className={`w-full py-3 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition-all ${
                hasInvoice
                  ? "bg-blue-700 hover:bg-blue-600 text-white shadow-lg shadow-blue-900/30"
                  : `${isDark ? 'bg-blue-900/20 text-blue-600 border-blue-800/30' : 'bg-gray-200 text-gray-500 border-gray-300'} border cursor-not-allowed`
              }`}
            >
              <Download className="w-4 h-4" />
              {hasInvoice ? "Download Invoice PDF" : "Invoice Not Available"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

// ─── Manager Access Modal (Responsive) ──────────────────────────────────────────────────────
const ManagerAccessModal = ({ managers, onClose, onSave, loading }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [selected, setSelected] = useState(
    managers.filter(m => m.hasBillingAccess).map(m => m.id)
  );
  const [saving, setSaving] = useState(false);

  const toggle = (id) =>
    setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

  const handleSaveClick = async () => {
    setSaving(true);
    await onSave(selected);
    setSaving(false);
    onClose();
  };

  const bgModal = isDark ? 'bg-[#0d1526]' : 'bg-white';
  const borderColor = isDark ? 'border-blue-800/50' : 'border-gray-300';
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-400' : 'text-gray-600';
  //const textMuted = isDark ? 'text-blue-500' : 'text-gray-500';
  const bgHover = isDark ? 'hover:bg-blue-900/20' : 'hover:bg-gray-100';
  const bgItem = isDark ? 'bg-blue-900/10' : 'bg-gray-50';
  const borderItem = isDark ? 'border-blue-800/30' : 'border-gray-200';

  if (loading) {
    return (
      <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${isDark ? 'bg-black/70' : 'bg-black/40'} backdrop-blur-sm`} onClick={onClose}>
        <div className={`w-full max-w-md ${bgModal} border ${borderColor} rounded-2xl p-6 text-center`}>
          <div className="w-8 h-8 mx-auto mb-3 border-2 border-blue-500 rounded-full border-t-transparent animate-spin" />
          <p className={`text-sm ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>Loading managers...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${isDark ? 'bg-black/70' : 'bg-black/40'} backdrop-blur-sm`} onClick={onClose}>
      <div
        className={`w-full max-w-md ${bgModal} border ${borderColor} rounded-2xl shadow-2xl p-4 md:p-6 max-h-[90vh] overflow-y-auto`}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className={`text-base font-bold ${textPrimary} md:text-lg`}>Billing Access — Managers</h3>
          <button onClick={onClose} className={`p-1 ${isDark ? 'text-blue-400 hover:text-white hover:bg-blue-900/30' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100'} transition-colors rounded-lg`}>
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className={`mb-4 text-xs ${isDark ? 'text-blue-500' : 'text-gray-500'}`}>Select which managers can view the Billing &amp; Plan section.</p>
        
        <div className="space-y-2 overflow-y-auto max-h-64">
          {managers.length === 0 ? (
            <div className={`py-8 text-center ${isDark ? 'text-blue-500' : 'text-gray-500'}`}>No managers found</div>
          ) : managers.map(m => (
            <label key={m.id} className={`flex items-center gap-3 p-3 transition-colors border cursor-pointer rounded-xl ${borderItem} ${bgItem} ${bgHover}`}>
              <input type="checkbox" checked={selected.includes(m.id)} onChange={() => toggle(m.id)} className="w-4 h-4 accent-blue-500" />
              <div className="flex items-center flex-1 gap-3">
                <div className={`flex items-center justify-center w-8 h-8 text-xs font-bold ${isDark ? 'text-blue-200' : 'text-blue-700'} rounded-full ${isDark ? 'bg-blue-700/40' : 'bg-blue-200'}`}>
                  {m.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-medium ${textPrimary} truncate`}>{m.name}</p>
                  <p className={`text-xs ${isDark ? 'text-blue-500' : 'text-gray-500'} truncate`}>{m.email}</p>
                  <p className={`text-xs ${isDark ? 'text-blue-600' : 'text-gray-500'}`}>{m.role || 'Manager'}</p>
                </div>
              </div>
              <span className={`text-xs px-2 py-0.5 rounded-full border whitespace-nowrap ${
                selected.includes(m.id)
                  ? isDark ? 'bg-green-900/30 text-green-300 border-green-700/30' : 'bg-green-100 text-green-700 border-green-700'
                  : isDark ? 'bg-gray-800 text-gray-500 border-gray-700' : 'bg-gray-200 text-gray-500 border-gray-200'
              }`}>
                {selected.includes(m.id) ? 'Access' : 'No Access'}
              </span>
            </label>
          ))}
        </div>
        
        <div className="flex flex-col gap-2 mt-5 sm:flex-row">
          <button
            onClick={handleSaveClick}
            disabled={saving}
            className="flex items-center justify-center gap-2 p-3 text-sm font-semibold text-white transition-colors bg-blue-700 rounded-xl hover:bg-blue-600 disabled:opacity-60"
          >
            {saving ? (
              <>
                <div className="w-4 h-4 border-2 border-white rounded-full border-t-transparent animate-spin" />
                Saving...
              </>
            ) : 'Save Changes'}
          </button>
          <button
            onClick={onClose}
            disabled={saving}
            className={`p-3 text-sm ${isDark ? 'text-blue-300' : 'text-gray-600'} transition-colors border rounded-xl ${isDark ? 'border-blue-600/50 hover:text-white' : 'border-gray-300 hover:text-gray-900'} disabled:opacity-60`}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Stat Card Component ──────────────────────────────────────────────────────────
const StatCard = ({ label, value, sub, color, icon: Icon }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  
  return (
    <div className={`p-3 border rounded-xl ${isDark ? 'bg-richblue-600/20 border-blue-700/80' : 'bg-gray-100 border-gray-300'} md:p-4 transition-colors duration-300`}>
      <div className="flex items-center justify-between">
        <p className={`text-xs ${isDark ? 'text-blue-300' : 'text-gray-600'} sm:text-sm`}>{label}</p>
        {Icon && <Icon className={`w-4 h-4 ${isDark ? 'text-blue-400' : 'text-blue-600'} md:w-5 md:h-5`} />}
      </div>
      <p className={`text-xl font-bold md:text-2xl ${color}`}>{value}</p>
      <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'} sm:text-sm`}>{sub}</p>
    </div>
  );
};

// ─── Mobile Plan Card ──────────────────────────────────────────────────────────
const MobilePlanCard = ({ plan, onClick }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  
  return (
    <div
      className={`p-4 transition-colors border cursor-pointer ${isDark ? 'bg-blue-950/10 border-blue-800/25 hover:bg-blue-900/20' : 'bg-gray-50 border-gray-200 hover:bg-gray-100'} rounded-xl`}
      onClick={() => onClick(plan)}
    >
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1 pr-3">
          <p className={`text-sm font-medium leading-snug ${isDark ? 'text-white' : 'text-gray-900'}`}>{plan.name}</p>
          <p className={`mt-0.5 text-xs ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>{plan.orgname}</p>
        </div>
        <p className={`text-base font-bold ${isDark ? 'text-green-300' : 'text-green-600'} whitespace-nowrap`}>
          ₹{(plan.ammount ?? plan.amount ?? 0).toLocaleString('en-IN')}
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <PlanTypeBadge type={plan.recipt} />
        <span className={`flex-1 text-xs ${isDark ? 'text-blue-400' : 'text-gray-500'} truncate`}>{plan.email}</span>
        <span className={`text-xs ${isDark ? 'text-blue-400' : 'text-gray-500'}`}>·</span>
        <span className={`text-xs ${isDark ? 'text-blue-400' : 'text-gray-500'} whitespace-nowrap`}>
          {new Date(plan.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}
        </span>
      </div>
      <div className="flex justify-end mt-2">
        <span className={`flex items-center gap-1 text-xs ${isDark ? 'text-blue-200' : 'text-gray-600'}`}>
          View Details <Eye className="w-3 h-3" />
        </span>
      </div>
    </div>
  );
};

// ─── Main Component ────────────────────────────────────────────────────────────
const OrgBillingComplete = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const toast = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.profile);
  const { token } = useSelector((state) => state.auth);
  const { managers } = useSelector((state) => state.manager);

  const managersData = typeof managers === 'string' ? JSON.parse(managers) : managers;
  const userDetails = typeof user === 'string' ? JSON.parse(user) : user;

  // ─── Theme-aware classes ──────────────────────────────────────────────
  const bgPrimary = isDark ? 'bg-[#0B0F1C]' : 'bg-gray-50';
  const bgCard = isDark ? 'bg-richblue-800/20' : 'bg-white/80';
  //const bgSection = isDark ? 'bg-richblue-800/20' : 'bg-gray-100';
  //const bgHeader = isDark ? 'bg-richblue-800/20' : 'bg-gray-100';
  const bgInput = isDark ? 'bg-richblue-600/20' : 'bg-gray-100';
  const bgTabContainer = isDark ? 'bg-blue-950/30' : 'bg-gray-100';
  const bgTabActive = isDark ? 'bg-blue-700' : 'bg-blue-500';
  
  const borderColor = isDark ? 'border-blue-700/80' : 'border-gray-300';
  //const borderLight = isDark ? 'border-blue-800/20' : 'border-gray-200';
  const borderInput = isDark ? 'border-blue-700/80' : 'border-gray-300';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-300' : 'text-gray-600';
  //const textMuted = isDark ? 'text-gray-400' : 'text-gray-500';
  //const textBlue = isDark ? 'text-blue-400' : 'text-blue-600';
  //const textGreen = isDark ? 'text-green-300' : 'text-green-700';
  
  //const shadowColor = isDark ? 'shadow-blue-900/20' : 'shadow-blue-200/30';
  //const shadowTable = isDark ? 'shadow-blue-800/60' : 'shadow-gray-300';

  const [loading, setLoading] = useState(true);
  const [loadingManagers, setLoadingManagers] = useState(true);
  const [activeTab, setActiveTab] = useState('plans');
  const [showManagerModal, setShowManagerModal] = useState(false);

  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const PER_PAGE = 8;

  const currentDate = new Date();

  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    date.setDate(1);
    return formatDateToInput(date);
  });

  const [endDate, setEndDate] = useState(() => {
    return formatDateToInput(getLastDayOfMonth(currentDate));
  });

  const [tempStartDate, setTempStartDate] = useState(startDate);
  const [tempEndDate, setTempEndDate] = useState(endDate);

  const [softwarePlans, setSoftwarePlans] = useState([]);
  //const [hardwarePlans, setHardwarePlans] = useState([]);
  const [managerAccessList, setManagerAccessList] = useState([]);

  // Wallet Analysis State
  const [walletHistoryData, setWalletHistoryData] = useState([]);
  const [walletStats, setWalletStats] = useState({
    maxBalance: 0,
    minBalance: 0,
    avgBalance: 0,
    totalTransactions: 0,
    recentTransactions: []
  });

  const orgData = useMemo(() => ({
    name: userDetails?.org_name || 'TechCorp Pvt Ltd',
    email: userDetails?.org_email || 'admin@techcorp.com',
    phone: userDetails?.phone_number || '+91 98765 43210',
    gst: userDetails?.gst_number || 'GST27AABCT1234A1Z5',
    address: userDetails?.location || '4th Floor, DLF Tower, Sector 25, Gurugram, Haryana - 122001',
    memberSince: userDetails?.createdAt?.split('T')[0] || 'Jan 2024',
    total_users: userDetails?.total_users || 0,
    wallet: {
      balance: userDetails?.wallet?.balance ?? 9160,
    },
  }), [userDetails]);

  const mngData = useMemo(() => ({
    name: userDetails?.manager_name,
    email: userDetails?.manager_email,
    org_name: userDetails?.org_id?.org_name || 'TechCorp Pvt Ltd',
    org_email: userDetails?.org_id?.org_email || 'admin@techcorp.com',
    phone: userDetails?.org_id?.phone_number || '+91 98765 43210',
    gst: userDetails?.org_id?.gst || 'GST27AABCT1234A1Z5',
    address: userDetails?.org_id?.location || '4th Floor, DLF Tower, Sector 25, Gurugram, Haryana - 122001',
    memberSince: userDetails?.org_id?.createdAt?.split("T")[0] || 'Jan 2024',
    total_users: userDetails?.org_id?.total_users || 0,
    wallet: {
      balance: userDetails?.org_id?.wallet?.balance ?? 9160,
    },
  }), [userDetails]);

  // ── Helper: Sort plans in descending order by createdAt ──────────────────────────
  const sortPlansDescending = (plansArray) => {
    if (!plansArray || !Array.isArray(plansArray)) return [];
    return [...plansArray].sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB - dateA;
    });
  };

  // ── Fetch Wallet Balance ─────────────────────────────────────────────────────────
  const fetchWalletBalance = useCallback(async () => {
    try {
      const res = await dispatch(GetWalletTracking());
      console.log("wallet tracking...", res);
      
      const walletData = res?.data?.data || res?.payload?.data || res;
      
      if (walletData && Array.isArray(walletData)) {
        const filtered = walletData.filter(item => {
          const itemDate = item.DateString?.split('T')[0];
          return itemDate >= startDate && itemDate <= endDate;
        });
        
        const ascendingData = [...filtered].sort((a, b) => 
          new Date(a.DateString) - new Date(b.DateString)
        );
        
        const chartData = ascendingData.map(item => ({
          date: item.DateString,
          totalAmount: item.totalamount,
          subtractAmount: item.subtractamount,
          totalUsers: item.orgId?.total_users || item.orgId?.totalUsers || 0,
          orgName: item.orgId?.org_name || item.orgId?.orgName
        }));
        
        setWalletHistoryData(chartData);
        
        const balances = chartData.map(d => d.totalAmount);
        const maxBalance = balances.length > 0 ? Math.max(...balances) : 0;
        const minBalance = balances.length > 0 ? Math.min(...balances) : 0;
        const avgBalance = balances.length > 0 ? Math.round(balances.reduce((a, b) => a + b, 0) / balances.length) : 0;
        
        const descendingData = [...filtered].sort((a, b) => 
          new Date(b.DateString) - new Date(a.DateString)
        );
        
        setWalletStats({
          maxBalance,
          minBalance,
          avgBalance,
          totalTransactions: chartData.length,
          recentTransactions: descendingData
        });
      }
    } catch (error) {
      console.error("Error fetching wallet data:", error);
    }
  },[dispatch, endDate, startDate]);

  // ── Fetch Managers ───────────────────────────────────────────────────────────
  const fetchManagers = useCallback(async () => {
    try {
      setLoadingManagers(true);
      await dispatch(Get_Managers_User(token));

      const processedManagers = (managersData || []).map(manager => ({
        id: manager._id || manager.id,
        name: manager.manager_name || manager.name,
        email: manager.manager_email || manager.email,
        role: manager.role || 'Manager',
        hasBillingAccess: manager.access || false,
      }));

      setManagerAccessList(processedManagers);
    } catch (err) {
      console.error("Error fetching managers:", err);
      toast.error("Failed to load managers data");
    } finally {
      setLoadingManagers(false);
    }
  },[dispatch, managersData, toast, token]);

  useEffect(() => {
    fetchManagers();
  }, [fetchManagers]);

  // ── Fetch Plans ──────────────────────────────────────────────────────────────
  const fetchPlans = useCallback(async () => {
    try {
      const softwareRes = await dispatch(GetSoftwarePlan(token));
      const sortedSoftwarePlans = sortPlansDescending(softwareRes || []);
      setSoftwarePlans(sortedSoftwarePlans);
      
      const hardwareRes = await dispatch(GetHardwarePlan(token));
      // eslint-disable-next-line
      const sortedHardwarePlans = sortPlansDescending(hardwareRes || []);
      //setHardwarePlans(sortedHardwarePlans);
    } catch (err) {
      console.error("Error fetching plans:", err);
      toast.error("Failed to load plans data");
    } finally {
      setLoading(false);
    }
  },[dispatch, toast, token]);
  
  useEffect(() => {
    if (token) fetchPlans();
  }, [token, fetchPlans]);

  useEffect(() => {
    if (token) fetchWalletBalance();
  }, [startDate, endDate, token, fetchWalletBalance]);

  // ── Filtered Plans ───────────────────────────────────────────────────────────
  const filteredByDatePlans = useMemo(() => {
    const startDateObj = new Date(startDate);
    startDateObj.setHours(0, 0, 0, 0);
    const endDateObj = new Date(endDate);
    endDateObj.setHours(23, 59, 59, 999);

    return softwarePlans.filter(plan => {
      if (!plan.createdAt) return false;
      const planDate = new Date(plan.createdAt);
      return planDate >= startDateObj && planDate <= endDateObj;
    });
  }, [softwarePlans, startDate, endDate]);

  const filteredPlans = useMemo(() => {
    if (!search) return filteredByDatePlans;
    return filteredByDatePlans.filter(plan =>
      plan.name?.toLowerCase().includes(search.toLowerCase()) ||
      plan.orgname?.toLowerCase().includes(search.toLowerCase()) ||
      plan.email?.toLowerCase().includes(search.toLowerCase())
    );
  }, [filteredByDatePlans, search]);

  const totalPages = Math.ceil(filteredPlans.length / PER_PAGE);
  const paginatedPlans = filteredPlans.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  const planSummary = useMemo(() => {
    const totalRevenue = softwarePlans.reduce((sum, p) => sum + (p.ammount ?? p.amount ?? 0), 0);
    const totalFilteredRevenue = filteredByDatePlans.reduce((sum, p) => sum + (p.ammount ?? p.amount ?? 0), 0);
    return {
      totalPlans: softwarePlans.length,
      totalRevenue,
      totalFilteredPlans: filteredByDatePlans.length,
      totalFilteredRevenue,
    };
  }, [softwarePlans, filteredByDatePlans]);

  const currentMonthRevenue = useMemo(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    start.setHours(0, 0, 0, 0);
    const end = getLastDayOfMonth(now);
    end.setHours(23, 59, 59, 999);

    return softwarePlans
      .filter(plan => {
        if (!plan.createdAt) return false;
        const d = new Date(plan.createdAt);
        return d >= start && d <= end;
      })
      .reduce((sum, p) => sum + (p.ammount ?? p.amount ?? 0), 0);
  }, [softwarePlans]);

  const TABS = [
    { id: 'plans', label: 'Transactions', icon: CreditCard },
    { id: 'wallet', label: 'Wallet Analysis', icon: TrendingUp },
    userDetails.role === "Organization" && { id: 'access', label: 'Manager Access', icon: UserCheck },
  ].filter(Boolean);

  const handleApplyDateFilter = () => {
    setStartDate(tempStartDate);
    setEndDate(tempEndDate);
    setPage(1);
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit', month: 'short', year: 'numeric'
    });
  };

  const handleSaveManagers = async (selectedIds) => {
    const changedManagers = managerAccessList.filter(manager => {
      const newAccess = selectedIds.includes(manager.id);
      return newAccess !== manager.hasBillingAccess;
    });

    if (changedManagers.length === 0) {
      toast.success('No changes to save');
      return;
    }

    try {
      const results = await Promise.all(
        changedManagers.map(manager =>
          dispatch(GiveManagerAccess(manager.id, selectedIds.includes(manager.id), token))
        )
      );

      const anyFailed = results.some(r => !r || r?.data?.success === false);
      
      if (!anyFailed) {
        setManagerAccessList(prev =>
          prev.map(m => ({
            ...m,
            hasBillingAccess: selectedIds.includes(m.id),
          }))
        );
        toast.success('Manager access updated successfully');
      } else {
        toast.error('Failed to update some manager access');
      }
    } catch (error) {
      console.error('Failed to update manager access:', error);
      toast.error('Failed to update manager access. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className={`min-h-screen ${bgPrimary} flex items-center justify-center transition-colors duration-300`}>
        <div className="text-center">
          <div className="w-10 h-10 mx-auto mb-3 border-2 border-blue-500 rounded-full border-t-transparent animate-spin" />
          <p className={`text-sm ${isDark ? 'text-blue-400/60' : 'text-gray-500'}`}>Loading plan requests...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen ${bgPrimary} text-white font-sans ${userDetails.role === "Manager" ? "pt-20 md:pt-24" : "pt-4 md:pt-0"} transition-colors duration-300`}>
      <div className="px-3 py-4 mx-auto space-y-4 max-w-7xl md:px-4 md:py-6 md:space-y-6">

        {/* ── Org Header (Responsive) ──────────────────────────────────────────────────────── */}
        {userDetails.role === "Organization" && (
          <div className={`p-3 border rounded-2xl ${bgCard} ${borderColor} md:p-4 transition-colors duration-300`}>
            <div className="flex flex-col gap-4 md:flex-row md:items-center">
              <div className="flex items-center flex-1 gap-3">
                <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 text-lg font-bold border shadow-lg rounded-2xl bg-gradient-to-br from-blue-600 to-blue-900 border-blue-500/20 shadow-blue-900/40 md:w-14 md:h-14 md:text-xl">
                  {orgData.name.slice(0, 2).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <h1 className={`text-lg font-bold ${textPrimary} truncate md:text-xl`}>{orgData.name}</h1>
                  <p className={`text-xs ${isDark ? 'text-blue-300' : 'text-gray-600'} truncate md:text-sm`}>{orgData.email}</p>
                  <div className="flex flex-wrap items-center gap-1 mt-1 md:gap-2">
                    <span className={`flex items-center gap-0.5 text-xs ${isDark ? 'text-blue-200' : 'text-gray-600'}`}><Phone className="w-3 h-3 md:w-4 md:h-4"/> {orgData.phone}</span>
                    <span className={`text-xs ${isDark ? 'text-blue-200' : 'text-gray-600'}`}>•</span>
                    <span className={`text-xs ${isDark ? 'text-blue-200' : 'text-gray-600'}`}>Since {orgData.memberSince}</span>
                  </div>
                </div>
              </div>

              {/* Wallet Card - Responsive */}
              <div className={`bg-gray-100 dark:bg-black border ${borderColor} rounded-xl p-2 min-w-[140px] md:min-w-[170px]`}>
                <p className={`text-[10px] md:text-xs font-medium tracking-wider ${isDark ? 'text-blue-200' : 'text-gray-500'} uppercase`}>Wallet Balance</p>
                <p className={`text-lg font-bold ${textPrimary} md:text-xl`}>
                  ₹{orgData.wallet.balance.toLocaleString('en-IN')}
                  <span className={`ml-1 text-xs font-normal ${isDark ? 'text-blue-200' : 'text-gray-500'}`}>INR</span>
                </p>
                <div className="flex items-center gap-1 mt-0.5">
                  <span className="w-1.5 h-1.5 bg-green-600 dark:bg-green-400 rounded-full animate-pulse" />
                  <span className={`text-[10px] text-green-500 dark:text-green-400/70 md:text-xs`}>Active</span>
                </div>
                <button
                  onClick={() => navigate('/purchase-software/plan')}
                  className="w-full py-1.5 mt-2 text-[10px] md:text-xs font-semibold text-white transition-colors bg-blue-700 rounded-lg hover:bg-blue-600"
                >
                  + Recharge
                </button>
              </div>
            </div>

            {/* Org Details */}
            <div className={`grid grid-cols-1 gap-2 p-2 mt-2 border-t ${isDark ? 'border-blue-800/20' : 'border-gray-200'} sm:grid-cols-2`}>
              <div>
                <p className={`text-[10px] ${isDark ? 'text-gray-300' : 'text-gray-500'} mb-0.5 md:text-xs`}>GST Number</p>
                <p className={`font-mono text-xs ${isDark ? 'text-blue-200' : 'text-gray-700'} break-all md:text-sm`}>{orgData.gst}</p>
              </div>
              <div>
                <p className={`text-[10px] ${isDark ? 'text-gray-300' : 'text-gray-500'} mb-0.5 md:text-xs`}>Billing Address</p>
                <p className={`text-xs leading-snug ${isDark ? 'text-blue-200' : 'text-gray-700'} break-words md:text-sm`}>{orgData.address}</p>
              </div>
            </div>
          </div>
        )}
        
        {/* ── Manager View Header ──────────────────────────────────────────────────────── */}
        {userDetails.role === "Manager" && (
          <div className={`p-3 border rounded-2xl ${bgCard} ${borderColor} md:p-4 transition-colors duration-300`}>
            <div className="flex flex-col gap-4 md:flex-row md:items-center">
              <div className="flex items-center flex-1 gap-3">
                <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 text-lg font-bold border shadow-lg rounded-2xl bg-gradient-to-br from-blue-600 to-blue-900 border-blue-500/20 shadow-blue-900/40 md:w-14 md:h-14 md:text-xl">
                  {mngData.org_name.slice(0, 2).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <h1 className={`text-lg font-bold ${textPrimary} truncate md:text-xl`}>{mngData.org_name}</h1>
                  <p className={`text-xs ${isDark ? 'text-blue-300' : 'text-gray-600'} truncate md:text-sm`}>{mngData.org_email}</p>
                  <div className="flex flex-wrap items-center gap-1 mt-1 md:gap-2">
                    <span className={`flex items-center gap-0.5 text-xs ${isDark ? 'text-blue-200' : 'text-gray-600'}`}><Phone className="w-3 h-3 md:w-4 md:h-4"/> {mngData.phone}</span>
                    <span className={`text-xs ${isDark ? 'text-blue-200' : 'text-gray-600'}`}>•</span>
                    <span className={`text-xs ${isDark ? 'text-blue-200' : 'text-gray-600'}`}>Since {mngData.memberSince}</span>
                  </div>
                </div>
              </div>

              <div className={`bg-gray-100 dark:bg-black border ${borderColor} rounded-xl p-2 min-w-[140px] md:min-w-[170px]`}>
                <p className={`text-[10px] md:text-xs font-medium tracking-wider ${isDark ? 'text-blue-200' : 'text-gray-400'} uppercase`}>Wallet Balance</p>
                <p className={`text-lg font-bold ${textPrimary} md:text-xl`}>
                  ₹{mngData.wallet.balance.toLocaleString('en-IN')}
                  <span className={`ml-1 text-xs font-normal ${isDark ? 'text-blue-200' : 'text-gray-500'}`}>INR</span>
                </p>
                <div className="flex items-center gap-1 mt-0.5">
                  <span className="w-1.5 h-1.5 dark:bg-green-400 bg-green-600 rounded-full animate-pulse" />
                  <span className={`text-[10px] dark:text-green-400/70 text-green-600 md:text-xs`}>Active</span>
                </div>
                <button
                  onClick={() => navigate('/purchase-software/plan')}
                  className="w-full py-1.5 mt-2 text-[10px] md:text-xs font-semibold text-white transition-colors bg-blue-700 rounded-lg hover:bg-blue-600"
                >
                  + Recharge
                </button>
              </div>
            </div>

            <div className={`grid grid-cols-1 gap-2 p-2 mt-2 border-t ${isDark ? 'border-blue-800/20' : 'border-gray-200'} sm:grid-cols-2`}>
              <div>
                <p className={`text-[10px] ${isDark ? 'text-gray-300' : 'text-gray-500'} mb-0.5 md:text-xs`}>GST Number</p>
                <p className={`font-mono text-xs ${isDark ? 'text-blue-200' : 'text-gray-700'} break-all md:text-sm`}>{mngData.gst}</p>
              </div>
              <div>
                <p className={`text-[10px] ${isDark ? 'text-gray-300' : 'text-gray-500'} mb-0.5 md:text-xs`}>Billing Address</p>
                <p className={`text-xs leading-snug ${isDark ? 'text-blue-200' : 'text-gray-700'} break-words md:text-sm`}>{mngData.address}</p>
              </div>
            </div>
          </div>
        )}
        
        {/* ── Stats Grid ────────────────────────────────────────────────────────────────── */}
        {userDetails.role === 'Organization' && activeTab === 'plans' && (
          <div className="grid grid-cols-2 gap-2 md:gap-3 sm:grid-cols-4">
            <StatCard label="Total Records" value={planSummary.totalFilteredPlans} sub={`Out of ${planSummary.totalPlans}`} color="text-blue-300" icon={CreditCard} />
            <StatCard label="Total Amount" value={`₹${planSummary.totalFilteredRevenue.toLocaleString('en-IN')}`} sub={`Total ₹${planSummary.totalRevenue.toLocaleString('en-IN')}`} color="text-green-500" icon={Wallet} />
            <StatCard label="Current Month" value={`₹${currentMonthRevenue.toLocaleString('en-IN')}`} sub="This month's total" color="text-yellow-300" icon={Calendar} />
            <StatCard label="Total Users" value={orgData.total_users} sub={`${orgData.total_users} users`} color="text-orange-500" icon={Users} />
          </div>
        )}

        {/* ── Tabs ────────────────────────────────────────────────────────────────────── */}
        <div className={`flex flex-wrap w-full gap-1 p-1 border ${bgTabContainer} ${borderColor} rounded-xl md:w-fit transition-colors duration-300`}>
          {TABS.map(tab => (
            <button
              key={tab.id}
              onClick={() => { setActiveTab(tab.id); if (tab.id !== 'plans') setPage(1); }}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium transition-all flex-1 md:flex-none justify-center ${
                activeTab === tab.id
                  ? `${bgTabActive} text-white shadow-lg ${isDark ? 'shadow-blue-900/40' : 'shadow-blue-500/30'}`
                  : `${isDark ? 'text-blue-300 hover:text-blue-100' : 'text-gray-600 hover:text-gray-900'}`
              }`}
            >
              <tab.icon className="w-3.5 h-3.5 md:w-4 md:h-4" />
              {tab.label}
            </button>
          ))}
        </div>

        {/* ── Plans Tab ───────────────────────────────────────────────────────── */}
        {activeTab === 'plans' && (
          <div className="space-y-4">
            {/* Search and Date Filter Row */}
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div className="relative flex-1 min-w-[0]">
                <Search className={`absolute w-4 h-4 transform -translate-y-1/2 left-3 top-1/2 ${isDark ? 'text-blue-400/60' : 'text-gray-400'}`} />
                <input
                  type="text"
                  placeholder="Search by name, organization or email..."
                  value={search}
                  onChange={e => { setSearch(e.target.value); setPage(1); }}
                  className={`w-full py-2 pr-4 text-sm ${textPrimary} ${bgInput} border ${borderInput} rounded-lg pl-9 placeholder-blue-400/40 focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
                />
              </div>
              <DateRangePicker
                startDate={tempStartDate}
                endDate={tempEndDate}
                onStartDateChange={setTempStartDate}
                onEndDateChange={setTempEndDate}
                onApply={handleApplyDateFilter}
              />
            </div>

            {/* Date Range Display */}
            <div className={`flex items-center gap-1.5 text-xs ${isDark ? 'text-blue-300' : 'text-gray-600'} md:text-sm`}>
              <Calendar className={`w-3.5 h-3.5 md:w-4 md:h-4 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
              <span>Showing from <strong className={textPrimary}>{formatDisplayDate(startDate)}</strong> to <strong className={textPrimary}>{formatDisplayDate(endDate)}</strong></span>
              <span className={isDark ? 'text-blue-400/60' : 'text-gray-400'}> ({filteredPlans.length} plans)</span>
            </div>

            {/* Desktop Table View */}
            <div className="hidden md:block">
              <div className={`border shadow-xl ${isDark ? 'bg-richblue-800/20 border-blue-700/80 shadow-blue-800/60' : 'bg-white border-gray-300 shadow-gray-300'} rounded-xl transition-colors duration-300`}>
                <div className="overflow-x-auto overflow-y-auto max-h-[500px] rounded-xl">
                  <table className="w-full text-left border-collapse">
                    <thead className={`sticky top-0 z-10 ${isDark ? 'bg-richblue-950' : 'bg-gray-50'}`}>
                      <tr className={`border-b ${isDark ? 'border-blue-800/30 bg-blue-900/10' : 'border-gray-200 bg-gray-50'}`}>
                        {['Name', 'Organization', 'Email', 'Phone No.', 'Amount', 'Created At', ''].map(h => (
                          <th key={h} className={`px-4 py-3 text-xs font-bold tracking-wider text-left ${isDark ? 'text-blue-300' : 'text-gray-700'} uppercase whitespace-nowrap`}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className={`divide-y ${isDark ? 'divide-blue-900/20' : 'divide-gray-200'}`}>
                      {paginatedPlans.length === 0 ? (
                        <tr>
                          <td colSpan="7" className={`py-12 text-center ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>No plan requests found in selected date range</td>
                        </tr>
                      ) : paginatedPlans.map((plan) => (
                        <tr
                          key={plan._id}
                          className={`transition-colors cursor-pointer ${isDark ? 'hover:bg-blue-900/10' : 'hover:bg-gray-50'}`}
                          onClick={() => setSelectedPlan(plan)}
                        >
                          <td className={`px-4 py-3 text-sm font-medium ${textPrimary} whitespace-nowrap`}>{plan.name}</td>
                          <td className={`px-4 py-3 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'} whitespace-nowrap`}>{plan.orgname}</td>
                          <td className={`px-4 py-3 text-sm ${isDark ? 'text-blue-300' : 'text-blue-600'} whitespace-nowrap`}>{plan.email}</td>
                          <td className={`px-4 py-3 text-sm font-light ${isDark ? 'text-gray-500' : 'text-gray-400'} whitespace-nowrap`}>{plan.phone}</td>
                          <td className={`px-4 py-3 text-sm font-semibold ${isDark ? 'text-green-300' : 'text-green-600'} whitespace-nowrap`}>
                            ₹{(plan.ammount ?? plan.amount ?? 0).toLocaleString('en-IN')}
                          </td>
                          <td className={`px-4 py-3 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'} whitespace-nowrap`}>
                            {new Date(plan.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                          </td>
                          <td className={`px-4 py-3 text-xs ${isDark ? 'text-blue-300 hover:text-blue-100' : 'text-blue-600 hover:text-blue-800'}`}>
                            <Eye className="w-4 h-4" />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Mobile Card View */}
            <div className="space-y-3 md:hidden">
              {paginatedPlans.length === 0 ? (
                <div className={`py-12 text-sm text-center ${isDark ? 'text-blue-400/40' : 'text-gray-400'}`}>No plan requests found</div>
              ) : paginatedPlans.map(plan => (
                <MobilePlanCard key={plan._id} plan={plan} onClick={setSelectedPlan} />
              ))}
            </div>

            {/* Responsive Pagination */}
            {totalPages > 1 && (
              <div className="flex flex-col items-center gap-3 pt-2 sm:flex-row sm:justify-between">
                <p className={`order-2 text-xs ${isDark ? 'text-blue-200' : 'text-gray-600'} sm:order-1`}>
                  Showing {(page - 1) * PER_PAGE + 1}–{Math.min(page * PER_PAGE, filteredPlans.length)} of {filteredPlans.length}
                </p>
                <div className="flex flex-wrap justify-center order-1 gap-1 sm:order-2">
                  <button
                    disabled={page === 1}
                    onClick={() => setPage(p => p - 1)}
                    className={`p-1.5 text-xs md:px-2 ${isDark ? 'text-blue-200' : 'text-gray-600'} disabled:opacity-30 transition-colors`}
                  >
                    <ChevronLeft className="w-3.5 h-3.5" />
                  </button>
                  {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) pageNum = i + 1;
                    else if (page <= 3) pageNum = i + 1;
                    else if (page >= totalPages - 2) pageNum = totalPages - 4 + i;
                    else pageNum = page - 2 + i;
                    return (
                      <button
                        key={pageNum}
                        onClick={() => setPage(pageNum)}
                        className={`px-2.5 py-1.5 text-xs rounded-lg transition-colors md:px-3 ${
                          pageNum === page 
                            ? `bg-blue-700 text-white border border-blue-500` 
                            : `border ${isDark ? 'border-gray-700/50 text-gray-500 hover:bg-blue-700/40 hover:text-gray-300' : 'border-gray-300 text-gray-500 hover:bg-gray-100 hover:text-gray-700'}`
                        }`}
                      >
                        {pageNum}
                      </button>
                    );
                  })}
                  <button
                    disabled={page === totalPages}
                    onClick={() => setPage(p => p + 1)}
                    className={`p-1.5 text-xs md:px-2 ${isDark ? 'text-blue-200' : 'text-gray-600'} disabled:opacity-30 transition-colors`}
                  >
                    <ChevronRight className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* ── Wallet Analysis Tab ───────────────────────────────────────────────────────── */}
        {activeTab === 'wallet' && (
          <div className="space-y-4">
            {/* Date Range Filter for Wallet */}
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-end">
              <DateRangePicker
                startDate={tempStartDate}
                endDate={tempEndDate}
                onStartDateChange={setTempStartDate}
                onEndDateChange={setTempEndDate}
                onApply={handleApplyDateFilter}
              />
            </div>

            {/* Date Range Display */}
            <div className={`flex items-center gap-1.5 text-xs ${isDark ? 'text-blue-300' : 'text-gray-600'} md:text-sm`}>
              <Calendar className={`w-3.5 h-3.5 md:w-4 md:h-4 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
              <span>Showing from <strong className={textPrimary}>{formatDisplayDate(startDate)}</strong> to <strong className={textPrimary}>{formatDisplayDate(endDate)}</strong></span>
              <span className={isDark ? 'text-blue-400/60' : 'text-gray-400'}> ({walletHistoryData.length} records)</span>
            </div>

            {/* Wallet Balance Chart */}
            {walletHistoryData.length > 0 ? (
              <>
                <div className={`p-4 border rounded-xl ${bgCard} ${borderColor} md:p-6 transition-colors duration-300`}>
                  <div className="flex items-center justify-between mb-6">
                    <div>
                      <h3 className={`text-base font-semibold ${textPrimary} md:text-lg`}>Balance History</h3>
                      <p className={`text-xs ${isDark ? 'text-blue-300' : 'text-gray-500'}`}>Daily wallet balance tracking</p>
                    </div>
                    <Wallet className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                  </div>
                  
                  <div className="h-80">
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={walletHistoryData} margin={{ top: 20, right: 30, left: 10, bottom: 10 }}>
                        <defs>
                          <linearGradient id="walletGradient" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#34d399" stopOpacity={0.3} />
                            <stop offset="95%" stopColor="#34d399" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke={isDark ? "#2563eb20" : "#93c5fd40"} />
                        <XAxis 
                          dataKey="date" 
                          stroke={isDark ? "#60a5fa" : "#4a5568"}
                          tick={{ fill: isDark ? '#93c5fd' : '#4a5568', fontSize: 11 }}
                          tickFormatter={(value) => {
                            const d = new Date(value);
                            return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
                          }}
                          angle={-45}
                          textAnchor="end"
                          height={70}
                          interval={walletHistoryData.length > 14 ? Math.floor(walletHistoryData.length / 14) : 0}
                        />
                        <YAxis 
                          stroke={isDark ? "#60a5fa" : "#4a5568"}
                          tick={{ fill: isDark ? '#93c5fd' : '#4a5568', fontSize: 11 }}
                          tickFormatter={(v) => '₹' + v.toLocaleString('en-IN')}
                          label={{ 
                            value: 'Balance (₹)', 
                            angle: -90, 
                            position: 'insideLeft',
                            style: { fill: isDark ? '#93c5fd' : '#4a5568', fontSize: 12 }
                          }}
                        />
                        <Tooltip content={<WalletBalanceTooltip />} />
                        <Legend 
                          formatter={(value) => <span className={isDark ? 'text-blue-200' : 'text-gray-700'}>Daily Balance</span>}
                          wrapperStyle={{ paddingTop: '10px' }}
                        />
                        <Line 
                          type="monotone" 
                          dataKey="totalAmount" 
                          stroke="#34d399" 
                          strokeWidth={2.5}
                          name="Balance"
                          dot={{ r: 4, fill: "#34d399", strokeWidth: 2 }}
                          activeDot={{ r: 6, fill: "#34d399", stroke: "#0f172a", strokeWidth: 2 }}
                          fillOpacity={0.3}
                          fill="url(#walletGradient)"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>

                {/* Recent Transactions Table */}
                {walletStats.recentTransactions.length > 0 && (
                  <div className={`p-4 border rounded-xl ${bgCard} ${borderColor} md:p-6 transition-colors duration-300`}>
                    <h3 className={`mb-4 text-base font-semibold ${textPrimary} md:text-lg`}>Balance History</h3>
                    <div className="overflow-x-auto">
                      <div className="max-h-[245px] overflow-y-auto relative">
                        <table className="w-full border-collapse">
                          <thead className="sticky top-0 z-10">
                            <tr className={`border-b ${isDark ? 'border-blue-800/30 bg-blue-900/10' : 'border-gray-200 bg-gray-50'} uppercase`}>
                              <th className={`px-3 py-3 text-xs font-bold tracking-wider text-left ${isDark ? 'text-blue-300' : 'text-gray-700'} whitespace-nowrap`}>Date</th>
                              <th className={`px-3 py-3 text-xs font-bold tracking-wider text-left ${isDark ? 'text-blue-300' : 'text-gray-700'} whitespace-nowrap`}>Total Users</th>
                              <th className={`px-3 py-3 text-xs font-bold tracking-wider text-left ${isDark ? 'text-blue-300' : 'text-gray-700'} whitespace-nowrap`}>Subtracted Amount</th>
                              <th className={`px-3 py-3 text-xs font-bold tracking-wider text-left ${isDark ? 'text-blue-300' : 'text-gray-700'} whitespace-nowrap`}>Current Balance</th>
                            </tr>
                          </thead>
                          <tbody>
                            {walletStats.recentTransactions.map((transaction, idx) => (
                              <tr 
                                key={idx} 
                                className={`border-b ${isDark ? 'border-blue-800/20 hover:bg-blue-900/20' : 'border-gray-200 hover:bg-gray-50'} transition-colors ${
                                  idx % 2 === 0 ? (isDark ? 'bg-blue-900/5' : 'bg-gray-50/5') : ''
                                }`}
                              >
                                <td className={`px-3 py-3 text-xs ${isDark ? 'text-gray-200' : 'text-gray-700'} whitespace-nowrap`}>
                                  {new Date(transaction.DateString).toLocaleDateString("en-IN", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric"
                                  })}
                                </td>
                                <td className={`px-3 py-3 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'} whitespace-nowrap`}>
                                  {transaction.subtractamount || transaction.orgId?.totalUsers || 0}
                                </td>
                                <td className="px-3 py-3 text-xs text-red-400 whitespace-nowrap">
                                  -₹{(transaction.subtractamount || 0).toLocaleString('en-IN')}
                                </td>
                                <td className={`px-3 py-3 text-xs font-medium text-green-500 whitespace-nowrap`}>
                                  ₹{(transaction.totalamount || 0).toLocaleString('en-IN')}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        
                        {/* Scroll Indicator */}
                        {walletStats.recentTransactions.length > 5 && (
                          <div className={`absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t ${isDark ? 'from-[#0B0F1C]' : 'from-gray-50'} to-transparent pointer-events-none`}></div>
                        )}
                      </div>
                      
                      {/* Scroll Hint for Mobile */}
                      {walletStats.recentTransactions.length > 3 && (
                        <div className="mt-3 text-center">
                          <p className={`text-xs ${isDark ? 'text-blue-400/60' : 'text-gray-400'} flex items-center justify-center gap-1`}>
                            <svg className="w-3 h-3 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                            </svg>
                            Scroll for more
                            <svg className="w-3 h-3 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                            </svg>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className={`flex flex-col items-center justify-center py-12 border rounded-xl ${bgCard} ${borderColor}`}>
                <Wallet className={`w-12 h-12 ${isDark ? 'text-blue-700' : 'text-gray-400'}`} />
                <p className={`mt-3 ${isDark ? 'text-blue-300' : 'text-gray-600'}`}>No wallet data available for selected date range</p>
              </div>
            )}
          </div>
        )}

        {/* ── Manager Access Tab ───────────────────────────────────────────────── */}
        {userDetails.role === "Organization" && activeTab === 'access' && (
          <div className={`p-4 border rounded-xl ${borderColor} ${bgCard} md:p-5 transition-colors duration-300`}>
            <div className="flex flex-col gap-3 mb-4 sm:flex-row sm:items-center sm:justify-between">
              <h3 className={`flex items-center gap-2 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'} md:text-base`}>
                <Users className={`w-4 h-4 md:w-5 md:h-5 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} /> Manager Billing Access
              </h3>
              <button
                onClick={() => setShowManagerModal(true)}
                className="text-xs px-3 py-1.5 bg-blue-700 hover:bg-blue-600 text-white rounded-lg transition-colors font-medium w-full sm:w-auto"
              >
                Manage Access
              </button>
            </div>
            <p className={`mb-4 text-xs ${isDark ? 'text-blue-500' : 'text-gray-500'}`}>Managers with access can view billing, plans, invoices, and transaction history.</p>
            
            <div className="space-y-2">
              {loadingManagers ? (
                <div className="py-8 text-center">
                  <div className="w-6 h-6 mx-auto border-2 border-blue-500 rounded-full border-t-transparent animate-spin" />
                  <p className={`mt-2 text-xs ${isDark ? 'text-blue-400/60' : 'text-gray-500'}`}>Loading managers...</p>
                </div>
              ) : managerAccessList.length === 0 ? (
                <div className={`py-8 text-center ${isDark ? 'text-blue-400/40' : 'text-gray-400'}`}>No managers found for this organization</div>
              ) : managerAccessList.map(m => (
                <div key={m.id} className={`flex flex-col gap-2 p-3 border rounded-xl ${isDark ? 'border-blue-800/20 bg-black/20' : 'border-gray-200 bg-gray-50'} sm:flex-row sm:items-center sm:justify-between transition-colors duration-300`}>
                  <div className="flex items-center gap-3">
                    <div className={`flex items-center justify-center text-xs font-bold ${isDark ? 'text-blue-200' : 'text-blue-700'} rounded-full w-9 h-9 ${isDark ? 'bg-blue-800/40' : 'bg-blue-200'}`}>
                      {m.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div className="min-w-0">
                      <p className={`text-sm font-medium ${textPrimary} truncate`}>{m.name}</p>
                      <p className={`text-xs ${isDark ? 'text-blue-500' : 'text-gray-500'} truncate`}>{m.role} · {m.email}</p>
                    </div>
                  </div>
                  <span className={`text-xs font-medium px-2.5 py-1 rounded-full border w-fit ${
                    m.hasBillingAccess
                      ? isDark ? 'bg-green-900/30 text-green-300 border-green-700/30' : 'bg-green-100 text-green-700 border-green-700'
                      : isDark ? 'bg-gray-800 text-gray-500 border-gray-700' : 'bg-gray-200 text-gray-500 border-gray-200'
                  }`}>
                    {m.hasBillingAccess ? 'Has Access' : 'No Access'}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* ── Modals / Drawers ─────────────────────────────────────────────────── */}
      {showManagerModal && (
        <ManagerAccessModal
          managers={managerAccessList}
          loading={loadingManagers}
          onClose={() => setShowManagerModal(false)}
          onSave={handleSaveManagers}
        />
      )}
      {selectedPlan && (
        <PlanDetailDrawer plan={selectedPlan} onClose={() => setSelectedPlan(null)} />
      )}
    </div>
  );
};

export default OrgBillingComplete;
